<template>
  <v-container class="mt-5 ml-2" fluid  v-if="[1258,2910].includes( getdatosUsuarioERPERP.iderp ) ||getdatosUsuarioERPERP.idpuesto != 31 ">
    <!-- v-if="usuariosAcceso.includes( getdatosUsuarioERPERP.iderp )" -->
    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-title primary-title class="text-subtitle-1">
            Reporte al momento
            <v-spacer></v-spacer>

            <v-btn
            	color="primary"
            	@click="initialize4()"
            	small
            	tile
            >
          		Consultar
          	</v-btn>

            <!-- <v-btn
              color="primary"
              @click="crearGrafica()"
              small
              tile
            >
              Consultar 2
            </v-btn> -->
          </v-card-title>

          <v-card-text>

            <!-- Titulo de las ventas diarias por escuela -->
          	<v-row>
          		<v-col cols="12" md="6">
		            <v-row>
		            	<v-col cols="12" v-if="ciclo" class="text-center">
		            		<span class="text-h4 black--text"> VENTAS POR CICLO </span>
		            		<br/>
		            		<span class="black--text text-h6"> {{ ciclo }} </span>
		            		<v-tooltip bottom max-width="320">
		            			<template v-slot:activator="{ on, attrs }">
		            				<v-btn
		            					icon
		            					small
		            					v-bind="attrs"
		            					v-on="on"
		            				>
		            					<v-icon small color="grey">mdi-information-outline</v-icon>
		            				</v-btn>
		            			</template>
		            			<span>
		            				Muestra el ciclo actual durante su primera semana. A partir del octavo día, ya muestra el siguiente ciclo para que esté visible con anticipación.
		            			</span>
		            		</v-tooltip>
		            	</v-col>

		            	<v-col cols="12" md="6" lg="6">
		            		<v-card color="shadowCard text-center">
		            		  <v-card-title primary-title>
		            		  	<v-spacer></v-spacer>
		            		    <div>Inscritos Fast
		            		    	<!-- <v-card color="#BD0014" dark class="pa-4 text-center text-h3 shadowCard" @click="tablaVentasCiclo = tablaFast, dialogVentasCiclo = true ">
		            		    		{{ totalFast }}
		            		    	</v-card> -->
		            		    </div>
		            		  	<v-spacer></v-spacer>
		            		  </v-card-title>
                      <v-card-text>
                        <!-- :value="(( dataTablaFastUno[ dataTablaFastUno.length - 1 ].total / dataTablaFastUno[ dataTablaFastUno.length - 1 ].meta  )*100)" -->
                        <v-progress-circular
                        :rotate="90"
                        :size="160"
                        :width="15"
                        color="red"
                        :value="avanceActualesFast"
                          @click="abrirVentasCiclo(false)"
                        >
                          <span class="text-h3"><b>{{ totalVentasFast }}</b></span>
                        </v-progress-circular>
                        <v-row class="align-center mt-4 text-h6">
                          <v-col cols="6">
                            <div>NI {{ ciclo }}</div>
                            <div>{{ metaFast }}</div>
                          </v-col>

                          <v-col cols="6">
                            <div>Faltan</div>
                            <div> {{ metaFast - totalVentasFast }} </div>
                          </v-col>

                          <v-col cols="12" class="grey--text text-subtitle-1">Cambios: {{ ventasCambiosFast }}</v-col>
                        </v-row>



                      </v-card-text>
		            		</v-card>
		            	</v-col>

		            	<v-col cols="12" md="6" lg="6">
		            		<v-card color="shadowCard text-center">
		            		  <v-card-title primary-title>
		            				<v-spacer></v-spacer>
		            		    <div>Inscritos Inbi
		            		    	<!-- <v-card color="#006487" dark class="pa-4 text-center text-h3 shadowCard" @click="tablaVentasCiclo = tablaInbi, dialogVentasCiclo = true ">
		            		    		{{ totalInbi }}
		            		    	</v-card> -->
		            		    </div>
		            		  	<v-spacer></v-spacer>
		            		  </v-card-title>

                      <v-card-text>
                        <v-progress-circular
                          @click="abrirVentasCiclo(true)"
                          :rotate="90"
                          :size="160"
                          :width="15"
                          :value="avanceActualesInbi"
                          color="blue"
                        >
                          <div class="text-h3"><b>{{ totalVentasInbi }}</b></div>
                        </v-progress-circular>
                        <v-row class="align-center mt-4 text-h6">
                          <v-col cols="6">
                            <div>NI {{ ciclo }}</div>
                            <div>{{ metaInbi }}</div>
                          </v-col>

                          <v-col cols="6">
                            <div>Faltan</div>
                            <div> {{ metaInbi - totalVentasInbi }} </div>
                          </v-col>
                          <v-col cols="12" class="grey--text text-subtitle-1">Cambios: {{ ventasCambiosInbi }}</v-col>

                        </v-row>

                      </v-card-text>

		            		</v-card>
		            	</v-col>
		            </v-row>
          		</v-col>


          		<v-col cols="12" md="6">
		            <v-row v-if="encabezados">

		          		<v-col cols="12" v-if="ciclo" class="text-center">
		            		<span class="text-h4 black--text"> VENTAS POR SEMANA </span>
		            		<br/>
		            		<span class="black--text text-h6">
			                <div>
			                  <span class="font-weight-bold text-h6">{{ encabezados.fecha_inicio_formatAnterior }}</span>
			                  <span class="font-weight-bold mx-4">al</span>
			                  <span class="font-weight-bold text-h6">{{ encabezados.fecha_final_formatAnterior }}</span>
			                </div>
		            		</span>
		            	</v-col>

		            	<v-col cols="12" md="12">
                    <v-card class="shadowCard">
		            		  <v-card-text class="black--text">
		                    <v-data-table
		                      :headers="headers5"
		                      :items="encabezados.matriculas_liquidadasSemAnt > encabezadosFast.matriculas_liquidadasSemAnt ? datosTablaHeaders6 :  datosTablaHeaders5 "
		                      class="elevation-0"
		                      dense
		                      mobile-breakpoint="200"
		                      hide-default-footer
		                      :items-per-page="datosTablaHeaders5.length"
		                    >
		                      <template v-slot:item.columna3="{ item }">
		                        <v-chip small @click="dataTablaSemana = encabezados.matriculas_liquidadasSemAnt > encabezadosFast.matriculas_liquidadasSemAnt ? vendedorasActualesFiltered :  vendedorasActualesFAST, tituloSemana = 'Ventas semana', dialogVendedorasSemana = true, alertInbi = true">{{ item.columna3 }} </v-chip>
		                      </template>
		                    </v-data-table>
		                    <v-data-table
		                      :headers="headers5"
		                      :items="encabezados.matriculas_liquidadasSemAnt < encabezadosFast.matriculas_liquidadasSemAnt ? datosTablaHeaders6 :  datosTablaHeaders5 "
		                      class="elevation-0"
		                      dense
		                      mobile-breakpoint="200"
		                      hide-default-footer
		                      :items-per-page="datosTablaHeaders6.length"
		                    >
		                      <template v-slot:item.columna3="{ item }">
		                        <v-chip small @click="dataTablaSemana = encabezados.matriculas_liquidadasSemAnt < encabezadosFast.matriculas_liquidadasSemAnt ? vendedorasActualesFiltered : vendedorasActualesFAST, tituloSemana = 'Ventas semana', dialogVendedorasSemana = true, alertInbi = false">{{ item.columna3 }} </v-chip>
		                      </template>
		                    </v-data-table>

		            		  </v-card-text>
		            		</v-card>
		            	</v-col>
		            </v-row>

                

                <br/>
                <br/>
                <br/>
                <br/>

                <v-card class="shadowCard" color="primary">
                  <v-tooltip bottom max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        absolute
                        top
                        right
                        class="white--text"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      <strong>Cómo se calcula el periodo:</strong><br/>
                      Del lunes de la semana 2 del ciclo actual, al domingo de la semana 1 del siguiente ciclo.
                    </span>
                  </v-tooltip>
                  <v-card-text>
                    <v-spacer></v-spacer>
                    <div class="text-h5 white--text text-center" align="center">
                      <span class="text-subtitle-1">Periodo del {{  this.formatFecha( segundaSemanaCicloActual ) }} al {{ this.formatFecha( segundoDomingoCicloProximo ) }}</span>
                      <br/>
                      Restan <span class="text-h3">{{ this.diasFaltantes( segundoDomingoCicloProximo )  }}</span> días para inscribir
                    </div>
                    <v-spacer></v-spacer>
                  </v-card-text>
                </v-card>

          		</v-col>
          	</v-row>


            <v-row>
              <v-col cols="12" md="6">
                <v-card class="shadowCard">
                  <v-card-title primary-title class="text-subtitle-1">
                    Inscritos Fast
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="headersNiSucursal"
                      :items="dataTablaFastUnoFiltered"
                      class="elevation-0"
                      hide-default-footer
                      :items-per-page="dataTablaFastUnoFiltered.length"
                      dense
                      mobile-breakpoint="200"
                    >
                      <template v-slot:item.position="{ index }">
                        {{ index + 1 }}
                      </template>

                      <template v-slot:item.no-data>
                        <v-btn
                          color="primary"
                          @click="initialize, inicializarFastAnt"
                          small
                        >
                          Actualizar
                        </v-btn>
                      </template>

                      <template v-slot:item.totalContactos="{ item }">
                        <v-chip @click="verDetalle(item.prospectos, item.vendedoras, item)"
                        style="cursor: pointer;"
                        color="green" text-color="white" small>
                          {{ item.totalContactos }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total_completos="{ item }">
                        <v-chip @click="verDetalle(item.completos)"
                        color="grey" text-color="white" small>
                          {{ item.total_completos - item.total_incompletos }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total_incompleto="{ item }">
                        <v-chip @click="verDetalle(item.incompletos)"
                        color="grey" text-color="white" small>
                          {{  item.total_incompletos }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total_merca="{ item }">
                        <v-chip @click="verDetalle(item.merca, item.vendedorasMerca)"
                        color="purple" text-color="white" small>
                          {{  item.total_merca }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total_sucursal="{ item }">
                        <v-chip @click="verDetalle(item.sucursal, item.vendedorasSucursal)"
                        color="purple" text-color="white" small>
                          {{  item.total_sucursal }}
                        </v-chip>
                      </template>

                      <template v-slot:item.inscritos_dentro_periodo="{ item }">
                        <v-chip @click="abrirDetalleInscritos(item.inscritos_dentro_list, 'Inscritos dentro del periodo - ' + (item.plantel || item.nombre_completo || ''))" color="green lighten-4" small style="cursor: pointer;">
                          {{ item.inscritos_dentro_periodo }}
                        </v-chip>
                      </template>

                      <template v-slot:item.inscritos_fuera_periodo="{ item }">
                        <v-chip @click="abrirDetalleInscritos(item.inscritos_fuera_list, 'Inscritos fuera del periodo - ' + (item.plantel || item.nombre_completo || ''))" color="orange lighten-4" small style="cursor: pointer;">
                          {{ item.inscritos_fuera_periodo }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total="{ item }">
                        <v-chip @click="abrirDetalleInscritos([...item.inscritos_dentro_list, ...item.inscritos_fuera_list], 'Inscritos Totales - ' + (item.plantel || item.nombre_completo || ''))"
                        color="primary" text-color="white" small>
                          {{ item.total }}
                        </v-chip>
                      </template>

                      <template v-slot:item.porcentaje_conversion_periodo="{ item }">
                        <!-- <v-chip color="green" text-color="white" small> -->
                          {{ item.porcentaje_conversion_periodo }}
                        <!-- </v-chip> -->
                      </template>

                      <template v-slot:item.porcentaje_cumplido="{ item }">
                        <v-chip color="blue" text-color="white" small>
                          {{ item.porcentaje_cumplido }}
                        </v-chip>
                      </template>
                      <!-- Fila de TOTALES -->
                      <template v-slot:body.append>
                        <tr class="font-weight-bold grey lighten-3">
                          <td></td>
                          <td></td>
                          <td><strong>Total</strong></td>
                          <td>
                            <v-chip small color="green" dark style="cursor: pointer;"
                              @click="verDetalle(dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').flatMap(i => i.prospectos || []), dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').flatMap(i => i.vendedoras || []))"
                            >
                              {{ dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.totalContactos || 0), 0) }}
                            </v-chip>
                          </td>
                          <td>
                            <v-chip small color="primary" style="cursor: pointer;"
                              @click="abrirDetalleInscritos([...dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').flatMap(i => i.inscritos_dentro_list || []), ...dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').flatMap(i => i.inscritos_fuera_list || [])], 'Inscritos Totales - ')"
                            >
                              {{ dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.total || 0), 0) }}
                            </v-chip>
                          </td>
                          <td>
                            <v-chip small color="green lighten-4" style="cursor: pointer;"
                              @click="abrirDetalleInscritos(dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').flatMap(i => i.inscritos_dentro_list || []), 'Inscritos dentro del periodo - TOTAL')"
                            >
                              {{ dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.inscritos_dentro_periodo || 0), 0) }}
                            </v-chip>
                          </td>
                          <td>
                            <v-chip small color="orange lighten-4" style="cursor: pointer;"
                              @click="abrirDetalleInscritos(dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').flatMap(i => i.inscritos_fuera_list || []), 'Inscritos fuera del periodo - TOTAL')"
                            >
                              {{ dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.inscritos_fuera_periodo || 0), 0) }}
                            </v-chip>
                          </td>
                          <td>
                            {{
                              dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.totalContactos || 0), 0) > 0
                                ? (( dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.inscritos_dentro_periodo || 0) + (i.inscritos_fuera_periodo || 0), 0) /
                                    dataTablaFastUnoFiltered.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.totalContactos || 0), 0) ) * 100).toFixed(2)
                                : '0.00'
                            }}%
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="6">
                <v-card class="shadowCard">
                  <v-card-title primary-title class="text-subtitle-1">
                    Inscritos Inbi
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="headersNiSucursal"
                      :items="dataTablaInbiUnoFiltered"
                      class="elevation-0"
                      hide-default-footer
                      :items-per-page="dataTablaInbiUnoFiltered.length"
                      dense
                      mobile-breakpoint="200"
                    >
                      <template v-slot:item.position="{ index }">
                        {{ index + 1 }}
                      </template>

                      <template v-slot:item.no-data>
                        <v-btn
                          color="primary"
                          @click="initialize, inicializarFastAnt"
                          small
                        >
                          Actualizar
                        </v-btn>
                      </template>

                      <template v-slot:item.totalContactos="{ item }">
                        <v-chip @click="verDetalle(item.prospectos, item.vendedoras, item)"
                        color="green" text-color="white" small>
                          {{ item.totalContactos }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total_completos="{ item }">
                        <v-chip @click="verDetalle(item.completos)"
                        color="grey" text-color="white" small>
                          {{ item.total_completos - item.total_incompletos }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total_incompleto="{ item }">
                        <v-chip @click="verDetalle(item.incompletos)"
                        color="grey" text-color="white" small>
                          {{  item.total_incompletos }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total_merca="{ item }">
                        <v-chip @click="verDetalle(item.merca, item.vendedorasMerca)"
                        color="purple" text-color="white" small>
                          {{  item.total_merca }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total_sucursal="{ item }">
                        <v-chip @click="verDetalle(item.sucursal, item.vendedorasSucursal)"
                        color="purple" text-color="white" small>
                          {{  item.total_sucursal }}
                        </v-chip>
                      </template>

                      <template v-slot:item.inscritos_dentro_periodo="{ item }">
                        <v-chip @click="abrirDetalleInscritos(item.inscritos_dentro_list, 'Inscritos dentro del periodo - ' + (item.plantel || item.nombre_completo || ''))" color="green lighten-4" small style="cursor: pointer;">
                          {{ item.inscritos_dentro_periodo }}
                        </v-chip>
                      </template>

                      <template v-slot:item.inscritos_fuera_periodo="{ item }">
                        <v-chip @click="abrirDetalleInscritos(item.inscritos_fuera_list, 'Inscritos fuera del periodo - ' + (item.plantel || item.nombre_completo || ''))" color="orange lighten-4" small style="cursor: pointer;">
                          {{ item.inscritos_fuera_periodo }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total="{ item }">
                        <v-chip @click="abrirDetalleInscritos([...item.inscritos_dentro_list, ...item.inscritos_fuera_list], 'Inscritos Totales - ' + (item.plantel || item.nombre_completo || ''))"
                        color="primary" text-color="white" small>
                          {{ item.total }}
                        </v-chip>
                      </template>

                      <template v-slot:item.porcentaje_conversion_periodo="{ item }">
                        <!-- <v-chip color="green" text-color="white" small> -->
                          {{ item.porcentaje_conversion_periodo }}
                        <!-- </v-chip> -->
                      </template>

                      <template v-slot:item.porcentaje_cumplido="{ item }">
                        <v-chip color="blue" text-color="white" small>
                          {{ item.porcentaje_cumplido }}
                        </v-chip>
                      </template>

                                            <!-- Fila de TOTALES -->
                      <template v-slot:body.append>
                        <tr class="font-weight-bold grey lighten-3">
                          <td></td>
                          <td></td>
                          <td><strong>Total</strong></td>
                          <td>
                            <v-chip small color="green" dark style="cursor: pointer;"
                              @click="verDetalle(dataTablaInbiUno.filter(i => i.plantel !== 'Total').flatMap(i => i.prospectos || []), dataTablaInbiUno.filter(i => i.plantel !== 'Total').flatMap(i => i.vendedoras || []))"
                            >
                              {{ dataTablaInbiUno.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.totalContactos || 0), 0) }}
                            </v-chip>
                          </td>
                          <td>
                            <v-chip small color="primary" style="cursor: pointer;"
                              @click="verQuienVendio(dataTablaInbiUno.filter(i => i.plantel !== 'Total').flatMap(i => i.completos || []), { plantel: 'TOTAL' })"
                            >
                              {{ dataTablaInbiUno.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.total || 0), 0) }}
                            </v-chip>
                          </td>
                          <td>
                            <v-chip small color="green lighten-4" style="cursor: pointer;"
                              @click="abrirDetalleInscritos(dataTablaInbiUno.filter(i => i.plantel !== 'Total').flatMap(i => i.inscritos_dentro_list || []), 'Inscritos dentro del periodo - TOTAL')"
                            >
                              {{ dataTablaInbiUno.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.inscritos_dentro_periodo || 0), 0) }}
                            </v-chip>
                          </td>
                          <td>
                            <v-chip small color="orange lighten-4" style="cursor: pointer;"
                              @click="abrirDetalleInscritos(dataTablaInbiUno.filter(i => i.plantel !== 'Total').flatMap(i => i.inscritos_fuera_list || []), 'Inscritos fuera del periodo - TOTAL')"
                            >
                              {{ dataTablaInbiUno.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.inscritos_fuera_periodo || 0), 0) }}
                            </v-chip>
                          </td>
                          <td>
                            {{
                              dataTablaInbiUno.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.totalContactos || 0), 0) > 0
                                ? (( dataTablaInbiUno.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.inscritos_dentro_periodo || 0) + (i.inscritos_fuera_periodo || 0), 0) /
                                    dataTablaInbiUno.filter(i => i.plantel !== 'Total').reduce((s,i) => s + (i.totalContactos || 0), 0) ) * 100).toFixed(2)
                                : '0.00'
                            }}%
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6" lg="6">
                <v-card>
                  <v-card-title primary-title class="text-subtitle-1">
                    Ventas por semana FAST (Sucursal)
                  </v-card-title>
                  <v-card-text>
                    <v-select
                      v-model="fastFilterSemana"
                      :items="ciudad"
                      label="Filtrar por ciudad"
                      dense
                      outlined
                    ></v-select>
                    <v-data-table
                      :headers="headersSucursalSemanaFAST"
                      :items="dataTablaFastFiltered"
                      class="elevation-0"
                      dense
                      mobile-breakpoint="200"
                      hide-default-footer
                      :items-per-page="dataTablaFastFiltered.length"
                    >

                      <template v-slot:item.matriculas_liquidadas="{ item }">
                        <v-chip
                          small
                          color="primary"
                          @click="alumnosSeleccion = item.nuevasMatriculas, dialogAlumnosSeleccion = true"
                        >
                          {{ item.matriculas_liquidadas }}
                        </v-chip>
                      </template>

                      <template v-slot:item.total_contactos="{ item }">
                        <v-chip
                          small
                          color="green"
                          dark
                          style="cursor: pointer;"
                          @click="abrirDialogoTwilio(item.contactos_twilio_lista, 'Contactos Twilio')">
                          {{ item.total_contactos || 0 }}
                        </v-chip>
                      </template>

                      <template v-slot:item.inscritos_dentro_periodo="{ item }">
                        <v-chip
                          small
                          color="green lighten-4"
                          @click="abrirDetalleInscritos(item.inscritos_dentro_list, 'Inscritos dentro del periodo (' + (item.nombre_completo || item.vendedora) + ')')"
                        >
                          {{ item.inscritos_dentro_periodo }}
                        </v-chip>
                      </template>

                      <template v-slot:item.inscritos_fuera_periodo="{ item }">
                        <v-chip
                          small
                          color="orange lighten-4"
                          @click="abrirDetalleInscritos(item.inscritos_fuera_list, 'Inscritos fuera del periodo (' + (item.nombre_completo || item.vendedora) + ')')"
                        >
                          {{ item.inscritos_fuera_periodo }}
                        </v-chip>
                      </template>

                      <template v-slot:item.porcentaje_conversion_periodo="{ item }">
                        {{ item.porcentaje_conversion_periodo }}%
                      </template>

                      <!-- Fila de TOTALES -->
                      <template v-slot:body.append>
                        <tr class="font-weight-bold grey lighten-3">
                          <td><strong>TOTAL</strong></td>
                          <td>
                            <v-chip small color="green" dark
                            @click="abrirTotalesContactosSemana(dataTablaFastFiltered)"
                            >
                            {{ dataTablaFastFiltered.reduce((s,i) => s + (i.total_contactos || 0), 0) }}
                          </v-chip>
                          </td>
                        <td>
                          <v-chip small color="primary"
                            @click="alumnosSeleccion = dataTablaFastFiltered.flatMap(i => i.nuevasMatriculas || []), dialogAlumnosSeleccion = true"
                          >
                            {{ dataTablaFastFiltered.reduce((s,i) => s + (i.matriculas_liquidadas || 0), 0) }}
                          </v-chip>
                        </td>
                          <td>
                            <v-chip small color="green lighten-4"
                              @click="abrirDetalleInscritos(dataTablaFastFiltered.flatMap(i => i.inscritos_dentro_list || []), 'Inscritos dentro del periodo - TOTAL')"
                            >
                              {{ dataTablaFastFiltered.reduce((s,i) => s + (i.inscritos_dentro_periodo || 0), 0) }}
                            </v-chip>
                          </td>
                          <td>
                            <v-chip small color="orange lighten-4"
                              @click="abrirDetalleInscritos(dataTablaFastFiltered.flatMap(i => i.inscritos_fuera_list || []), 'Inscritos fuera del periodo - TOTAL')"
                            >
                              {{ dataTablaFastFiltered.reduce((s,i) => s + (i.inscritos_fuera_periodo || 0), 0) }}
                            </v-chip>
                          </td>
                          <td>
                            {{
                              dataTablaFastFiltered.reduce((s,i) => s + (i.total_contactos || 0), 0) > 0
                                ? (( dataTablaFastFiltered.reduce((s,i) => s + (i.inscritos_dentro_periodo || 0) + (i.inscritos_fuera_periodo || 0), 0) /
                                    dataTablaFastFiltered.reduce((s,i) => s + (i.total_contactos || 0), 0) ) * 100).toFixed(2)
                                : '0.00'
                            }}%
                          </td>
                        </tr>
                      </template>

                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="6" lg="6">
                <v-card>
                  <v-card-title primary-title class="text-subtitle-1">
                    Ventas por semana INBI (Sucursal)
                  </v-card-title>
                  <v-card-text>
                    <v-select v-model="inbiFilterSemana" :items="ciudad" label="Filtrar por ciudad" dense outlined></v-select>
                    <v-data-table :headers="headersSucursalSemanaINBI" :items="dataTablaInbiFiltered" class="elevation-0" dense
                      mobile-breakpoint="200" hide-default-footer :items-per-page="dataTablaInbiFiltered.length">
                      <template v-slot:item.matriculas_liquidadas="{ item }">
                        <v-chip small color="primary"
                          @click="alumnosSeleccion = item.nuevasMatriculas, dialogAlumnosSeleccion = true">
                          {{ item.matriculas_liquidadas }}
                        </v-chip>
                      </template>
                      <template v-slot:item.total_contactos="{ item }">
                        <v-chip small color="green" dark
                          style="cursor: pointer;"
                          @click="abrirDialogoTwilio(item.contactos_twilio_lista, 'Contactos Twilio')">
                          {{ item.total_contactos || 0 }}
                        </v-chip>
                      </template>
                      <template v-slot:item.inscritos_dentro_periodo="{ item }">
                        <v-chip small color="green lighten-4"
                          @click="abrirDetalleInscritos(item.inscritos_dentro_list, 'Inscritos dentro del periodo (' + (item.nombre_completo || item.vendedora) + ')')">
                          {{ item.inscritos_dentro_periodo }}
                        </v-chip>
                      </template>
                      <template v-slot:item.inscritos_fuera_periodo="{ item }">
                        <v-chip small color="orange lighten-4"
                          @click="abrirDetalleInscritos(item.inscritos_fuera_list, 'Inscritos fuera del periodo (' + (item.nombre_completo || item.vendedora) + ')')">
                          {{ item.inscritos_fuera_periodo }}
                        </v-chip>
                      </template>
                      <template v-slot:item.porcentaje_conversion_periodo="{ item }">
                        {{ item.porcentaje_conversion_periodo }}%
                      </template>

                      <!-- Fila de TOTALES -->
                      <template v-slot:body.append>
                        <tr class="font-weight-bold grey lighten-3">
                          <td><strong>TOTAL</strong></td>
                          <td>
                            <v-chip small color="green" dark @click="abrirTotalesContactosSemana(dataTablaInbiFiltered)">
                              {{dataTablaInbiFiltered.reduce((s, i) => s + (i.total_contactos || 0), 0)}}
                            </v-chip>
                          </td>
                          <td>
                            <v-chip small color="primary"
                              @click="alumnosSeleccion = dataTablaInbiFiltered.flatMap(i => i.nuevasMatriculas || []), dialogAlumnosSeleccion = true">
                              {{dataTablaInbiFiltered.reduce((s, i) => s + (i.matriculas_liquidadas || 0), 0)}}
                            </v-chip>
                          </td>
                          <td>
                            <v-chip small color="green lighten-4"
                              @click="abrirDetalleInscritos(dataTablaInbiFiltered.flatMap(i => i.inscritos_dentro_list || []), 'Inscritos dentro del periodo - TOTAL')">
                              {{dataTablaInbiFiltered.reduce((s, i) => s + (i.inscritos_dentro_periodo || 0), 0)}}
                            </v-chip>
                          </td>
                          <td>
                            <v-chip small color="orange lighten-4"
                              @click="abrirDetalleInscritos(dataTablaInbiFiltered.flatMap(i => i.inscritos_fuera_list || []), 'Inscritos fuera del periodo - TOTAL')">
                              {{dataTablaInbiFiltered.reduce((s, i) => s + (i.inscritos_fuera_periodo || 0), 0)}}
                            </v-chip>
                          </td>
                          <td>
                            {{
                              dataTablaInbiFiltered.reduce((s, i) => s + (i.total_contactos || 0), 0) > 0
                                ? ((dataTablaInbiFiltered.reduce((s, i) => s + (i.inscritos_dentro_periodo || 0) +
                                  (i.inscritos_fuera_periodo || 0), 0) /
                                  dataTablaInbiFiltered.reduce((s, i) => s + (i.total_contactos || 0), 0)) * 100).toFixed(2)
                                : '0.00'
                            }}%
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-card class="shadowCard">
                  <v-card-title primary-title class="text-subtitle-1">
                    RI FAST
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="headersRI"
                      :items="resultadoRi.riPlantelesFast"
                      sort-by="calories"
                      class="elevation-0 mt-4"
                      hide-default-footer
                      :items-per-page="20"
                      dense
                      mobile-breakpoint="200"
                      id="kpi2"
                    >

                      <template v-slot:item.index="{ index }">
                        <div v-if="index != resultadoRi.riPlantelesFast.length - 1">
                          {{ index + 1 }}
                        </div>
                      </template>

                      <template v-slot:item.estado="{ item }">
                        <div>
                          {{ traducirEstado(item.estado) }}
                        </div>
                      </template>

                      <template v-slot:no-data>
                        <v-btn
                          color="primary"
                          @click="initialize, inicializarFastAnt"
                          small
                        >
                          Actualizar
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>

              </v-col>

              <v-col cols="12" md="6">
                <v-card class="shadowCard">
                  <v-card-title primary-title class="text-subtitle-1">
                    RI INBI
                  </v-card-title>
                  <div style="padding: 0 1rem 0 1rem;">
                    <v-select
                      v-model="inbiFilter"
                      :items="ciudad"
                      @change="onCiudadChangeRI()"
                      label="Filtrar por ciudad"
                      dense
                      outlined
                    ></v-select>
                  </div>
                  <v-card-text>
                    <v-data-table
                :headers="headersRI"
                :items="resultadoRiFiltro"
                sort-by="calories"
                class="elevation-0 mt-4"
                hide-default-footer
                :items-per-page="50"
                dense
                mobile-breakpoint="200"
                id="kpi"
              >
                <template  v-slot:item.index="{ index }">
                  <div v-if="index != resultadoRi.riPlantelesInbi.length - 1">
                    {{ index + 1 }}
                  </div>
                </template>

                <template v-slot:item.estado="{ item }">
                  <div>
                    {{ traducirEstado(item.estado) }}
                  </div>
                </template>

                <template v-slot:no-data>
                  <v-btn
                    color="primary"
                    @click="initialize, inicializarFastAnt"
                    small
                  >
                    Actualizar
                  </v-btn>
                </template>


              </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Ejemplo: título + badge -->
              <v-col cols="12" md="6">
  <v-card class="shadowCard" color="white">
    <v-card-title class="text-subtitle-1">
      Pagos rechazados
    </v-card-title>

    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="6" class="d-flex justify-center justify-sm-start mb-2">
          <v-badge
            :content="ingresosRechazadosFast.length"
            color="red"
            overlap
          >
            <v-chip
              color="red lighten-4"
              text-color="red darken-2"
              class="font-weight-medium"
              @click="abrirModalPagosRechazados('fast')"
              outlined
              pill
            >
              <v-icon left small color="red darken-2">
                mdi-alert-circle-outline
              </v-icon>
              Pagos Rechazados FAST
            </v-chip>
          </v-badge>
        </v-col>

        <v-col cols="12" sm="6" class="d-flex justify-center justify-sm-start">
          <v-badge
            :content="ingresosRechazadosInbi.length"
            color="indigo"
            overlap
          >
            <v-chip
              color="indigo lighten-4"
              text-color="indigo darken-2"
              class="font-weight-medium"
              @click="abrirModalPagosRechazados('inbi')"
              outlined
              pill
            >
              <v-icon left small color="indigo darken-2">
                mdi-alert-circle-outline
              </v-icon>
              Pagos Rechazados INBI
            </v-chip>
          </v-badge>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</v-col>



            </v-row>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12">
        <v-tabs v-model="tabBono" background-color="transparent" color="primary">
          <v-tab class="text-none">Bono de fin de semana</v-tab>
          <v-tab class="text-none">Bono de RI</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabBono">
          <v-tab-item eager>
            <div class="pt-2">
            <TablaBonoVendedoras
              ref="tablaBonoVendedoras"
              :total-inbi="totalVentasInbi"
              :total-fast="totalVentasFast"
            />
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="pt-2">
            <TablaBonoRI v-if="tabBono == 1" ref="tablaBonoRI" />
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <!-- Mostrar los alumnos (sin hide-overlay para que pueda apilarse encima de otros v-dialog, p. ej. Ventas por ciclo) -->
    <v-dialog
      v-model="dialogAlumnos"
      transition="dialog-bottom-transition"
      max-width="1200"
      content-class="dialog-alumnos-ventas-ciclo"
    >
      <v-card>
        <v-card-title primary-title>
          Alumnos
          <v-spacer></v-spacer>

          <v-btn
            class="mr-10"
            small
            dark
            color="green"
            tile
            @click="exportarAlumnos( alumnos , 'ALUMNOS_NI' )"
          >
            <!-- v-if="![18,40,19,17,53,52,57].includes( getdatosUsuarioERPERP.idpuesto )" -->
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>

        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersAlumnos"
            :items="alumnos"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
          >
            <template v-slot:item.twilio="{ item }">
              <v-chip
                :color="item.twilio ? 'green' : 'red'"
                dark
                small
                @click="abrirConversacion(item)"
              >
                {{ item.twilio ? $options.filters.formatTelefono(item.twilio) : 'N/A' }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="dialogAlumnos = false"
            small
            absolute
            top
            right
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>


    
    <!-- Ventas por ciclo por vendedora -->
    <v-dialog
      v-model="dialogVentasCiclo"
      max-width="1000px"
    >
      <v-card>
      	<v-card-title primary-title class="text-subtitle-1">
      	  Ventas por ciclo por vendedora
      	</v-card-title>
        <v-card-text>

          <v-select
            v-model="inbiFilter"
            :items="ciudad"
            @change="onCiudadChangeVentasCicloVendedora"
            label="Filtrar por ciudad"
            dense
            outlined
          ></v-select>

	      	<v-data-table
            :headers="headers"
            :items="tablaVentasCiclo"
            item-key="vendedora"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
            :items-per-page="tablaVentasCiclo.length"
            hide-default-footer
          >
            <template v-slot:item.completos="{ item }">
              <v-chip
                small
                color="primary"
                @click="abrirDialog( item.completosA )"
              >
                {{ item.completos }}
              </v-chip>
            </template>

            <template v-slot:item.total_contactos="{ item }">
              <v-chip
                small
                color="green"
                dark
                @click="abrirDialogoTwilio(item)"
              >
                {{ item.total_contactos }}
              </v-chip>
            </template>

            <template v-slot:item.porcentaje_conversion_periodo="{ item }">
              {{ item.porcentaje_conversion_periodo }}%
            </template>

            <template v-slot:item.inscritosTotalesCount="{ item }">
              <v-chip
                small
                color="primary"
                @click.stop="abrirDialogAlumnosInscritosTotalesVentasCiclo(item)"
              >
                {{ item.inscritosTotalesCount || 0 }}
              </v-chip>
            </template>

            <template v-slot:item.inscritosDentroPeriodoCount="{ item }">
              <v-chip
                small
                color="green"
                dark
                @click.stop="abrirDialogAlumnosInscritosDentroPeriodoVentasCiclo(item)"
              >
                {{ item.inscritosDentroPeriodoCount || 0 }}
              </v-chip>
            </template>

            <template v-slot:item.inscritosFueraPeriodoCount="{ item }">
              <v-chip
                small
                color="orange"
                dark
                @click="abrirDetalleInscritos(item.inscritosFueraPeriodo, 'Inscritos fuera del periodo - ' + (item.plantel || item.nombre_completo || ''))"
              >
                {{ item.inscritosFueraPeriodoCount || 0 }}
              </v-chip>
            </template>

            <template v-slot:item.porcentaje_conversion="{ item }">
              <b :class="item.porcentaje_conversion > 0 ? 'green--text' : ''" >
                {{ item.porcentaje_conversion || '0.00' }}%
              </b>
            </template>


            <template v-slot:item.ventasAyer="{ item }">
              <v-chip
                small
                color="primary"
                @click="abrirDialog( item.ventasAyerDetalle )"
              >
                {{ item.ventasAyer }}
              </v-chip>
            </template>

            <template v-slot:item.ventasAntier="{ item }">
              <v-chip
                small
                color="primary"
                @click="abrirDialog( item.ventasAntierDetalle )"
              >
                {{ item.ventasAntier }}
              </v-chip>
            </template>


            <template v-slot:item.tendencia="{ item }">

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" v-if="item.tendencia == 2"><v-icon color="green"  small>mdi-arrow-up-bold</v-icon><b>{{ item.diferencia }}</b></span>
                  <span v-bind="attrs" v-on="on" v-if="item.tendencia == 3"><v-icon color="red"    small>mdi-arrow-down-thick</v-icon><b>{{ item.diferencia }}</b></span>
                  <span v-bind="attrs" v-on="on" v-if="item.tendencia == 1"><v-icon color="orange" small>mdi-equal</v-icon><b>{{ item.diferencia }}</b></span>
                </template>
                <span>( {{ item.ventasAyer }} (ayer) - {{ item.ventasAntier }}( antier ) ) </span>
              </v-tooltip>

            </template>

          </v-data-table>

          <!-- <v-alert
            v-if="contactosInvisibles > 0"
            dense
            type="info"
            text
            class="mt-4 mb-0"
          >
            <strong>Contactos de otros departamentos o no asignados ({{ contactosInvisibles }} contactos)</strong>
            <div class="text-caption mt-1">
              Existen <b>{{ contactosInvisibles }}</b> prospectos (y <b>{{ inscritosInvisibles }}</b> inscripciones) que pertenecen al ciclo actual global, 
              pero NO se listan en las filas individuales de arriba porque fueron generados por usuarios inactivos o por otras áreas, incluidos los que nadie atendió o 
              los que fueron gestionados por puestos que no son vendedoras. <br/> La fila <b>TOTAL</b> sí los suma internamente para coincidir exactamente con la tabla General.
            </div>
          </v-alert> -->

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            small
            dark
            rounded
            color="green"
            tile
            @click="exportarVentasCiclo()"
          >
            <v-icon left>mdi-microsoft-excel</v-icon>
            Exportar
          </v-btn>
          <v-btn color="black" dark small @click="tablaVentasCiclo = [], dialogVentasCiclo = false">
          	Cancelar
          </v-btn>

          <v-btn icon color="black" top right absolute @click="tablaVentasCiclo = [], dialogVentasCiclo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ventas por ciclo por vendedora -->
    <v-dialog
      v-model="dialogVendedorasSemana"
      max-width="600px"
    >
      <v-card>
      	<v-card-title primary-title class="text-subtitle-1">
      	 	{{ tituloSemana }}
      	</v-card-title>
        <v-card-text>
          <v-select
            v-model="inbiFilter"
            :items="ciudad"
            label="Filtrar por ciudad"
            dense
            outlined
          ></v-select>
          <v-alert type="info" dense outlined v-if="alertInbi">
          Los contactos faltantes corresponden a la teacher <strong>ANA MOLINA</strong> que se solicitó no mostrar en la tabla.
          </v-alert>
	      	<v-data-table
	          :headers="headers2"
	          :items="dataTablaSemanaFiltered"
	          class="elevation-0"
	          dense
	          mobile-breakpoint="200"
	          hide-default-footer
	          :items-per-page="dataTablaSemana.length"
	        >

            <template v-slot:item.matriculas_liquidadas="{ item }">
              <v-chip
                small
                color="primary"
                @click="alumnosSeleccion = item.nuevasMatriculas, dialogAlumnosSeleccion = true"
              >
                {{ item.matriculas_liquidadas }}
              </v-chip>
            </template>

            <template v-slot:item.total_contactos="{ item }">
              <v-chip
                small
                color="green"
                dark
                @click="abrirDialogoTwilio(item)"
              >
                {{ item.total_contactos || 0 }}
              </v-chip>
            </template>

            <template v-slot:item.inscritos_dentro_periodo="{ item }">
              <v-chip
                small
                color="green lighten-4"
                @click="abrirDetalleInscritos(item.inscritos_dentro_list, 'Inscritos dentro del periodo (' + (item.nombre_completo || item.vendedora) + ')')"
              >
                {{ item.inscritos_dentro_periodo }}
              </v-chip>
            </template>

            <template v-slot:item.inscritos_fuera_periodo="{ item }">
              <v-chip
                small
                color="orange lighten-4"
                @click="abrirDetalleInscritos(item.inscritos_fuera_list, 'Inscritos fuera del periodo (' + (item.nombre_completo || item.vendedora) + ')')"
              >
                {{ item.inscritos_fuera_periodo }}
              </v-chip>
            </template>

            <template v-slot:item.porcentaje_conversion_periodo="{ item }">
              {{ item.porcentaje_conversion_periodo }}%
            </template>

            <!-- Fila de TOTALES -->
            <template v-slot:body.append>
              <tr class="font-weight-bold grey lighten-3">
                <td><strong>TOTAL</strong></td>
                <td>
                  <v-chip small color="green" dark
                  @click="abrirTotalesContactosSemana(dataTablaSemanaFiltered)"
                  >
                  {{ dataTablaSemanaFiltered.reduce((s,i) => s + (i.total_contactos || 0), 0) }}
                </v-chip>
              </td>
              <td>
                <v-chip small color="primary"
                  @click="alumnosSeleccion = dataTablaSemanaFiltered.flatMap(i => i.nuevasMatriculas || []), dialogAlumnosSeleccion = true"
                >
                  {{ dataTablaSemanaFiltered.reduce((s,i) => s + (i.matriculas_liquidadas || 0), 0) }}
                </v-chip>
              </td>
                <td>
                  <v-chip small color="green lighten-4"
                    @click="abrirDetalleInscritos(dataTablaSemanaFiltered.flatMap(i => i.inscritos_dentro_list || []), 'Inscritos dentro del periodo - TOTAL')"
                  >
                    {{ dataTablaSemanaFiltered.reduce((s,i) => s + (i.inscritos_dentro_periodo || 0), 0) }}
                  </v-chip>
                </td>
                <td>
                  <v-chip small color="orange lighten-4"
                    @click="abrirDetalleInscritos(dataTablaSemanaFiltered.flatMap(i => i.inscritos_fuera_list || []), 'Inscritos fuera del periodo - TOTAL')"
                  >
                    {{ dataTablaSemanaFiltered.reduce((s,i) => s + (i.inscritos_fuera_periodo || 0), 0) }}
                  </v-chip>
                </td>
                <td>
                  {{
                    dataTablaSemanaFiltered.reduce((s,i) => s + (i.total_contactos || 0), 0) > 0
                      ? (( dataTablaSemanaFiltered.reduce((s,i) => s + (i.inscritos_dentro_periodo || 0) + (i.inscritos_fuera_periodo || 0), 0) /
                           dataTablaSemanaFiltered.reduce((s,i) => s + (i.total_contactos || 0), 0) ) * 100).toFixed(2)
                      : '0.00'
                  }}%
                </td>
              </tr>
            </template>

	        </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            small
            dark
            color="green"
            tile
            rounded
            @click="exportarVentasSemana()"
          >
            <v-icon left>mdi-microsoft-excel</v-icon>
            Exportar
          </v-btn>
          <v-btn color="black" dark small @click="dialogVendedorasSemana = false">
          	Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Ventas por ciclo por vendedora -->
    <v-dialog
      v-model="dialogAlumnosSeleccion"
      max-width="1200px"
    >
      <v-card>
        <v-card-title primary-title class="text-subtitle-1">
          Alumnos inscritos
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersAlumno"
            :items="alumnosSeleccion"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
            hide-default-footer
            :items-per-page="alumnosSeleccion.length"
          >
            <template v-slot:item.fecha_alta="{ item }">
              {{ item.fecha_alta ? item.fecha_alta.toString().slice(0, 10) : '' }}
            </template>
            <template v-slot:item.fecha_alta_prospecto="{ item }">
              {{ item.fecha_alta_prospecto ? item.fecha_alta_prospecto.toString().slice(0, 10) : '' }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark small @click="dialogAlumnosSeleccion = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Detalle de Inscritos (Dentro/Fuera de Periodo) -->
    <v-dialog
      v-model="dialogDetalleInscritos"
      max-width="1200px"
    >
      <v-card>
        <v-card-title class="headline blue darken-3 white--text py-2">
          Detalle de {{ tituloDetalleInscritos }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogDetalleInscritos = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-data-table
            :headers="headersDetalleInscritos"
            :items="itemsDetalleInscritos"
            :loading="loadingDetalleInscritos"
            class="elevation-1"
            dense
            mobile-breakpoint="200"
            :items-per-page="15"
          >
            <template v-slot:item.dias_transcurridos="{ item }">
              <v-chip :color="item.dias_transcurridos > 15 ? 'red' : (item.dias_transcurridos > 7 ? 'orange' : 'green')" dark x-small>
                {{ item.dias_transcurridos }} días
              </v-chip>
            </template>
            <template v-slot:item.fecha_alta_lead="{ item }">
              {{ formatFecha(item.fecha_alta_lead) }}
            </template>
            <template v-slot:item.fecha_inscripcion="{ item }">
              {{ formatFecha(item.fecha_inscripcion) }}
            </template>
            <template v-slot:item.fecha_alta="{ item }">
              {{ item.fecha_alta ? item.fecha_alta.toString().slice(0, 10) :  '' }}
            </template>
            <template v-slot:item.fecha_alta_prospecto="{ item }">
              {{ item.fecha_alta_prospecto ? item.fecha_alta_prospecto.toString().slice(0, 10) : item.fecha_creacion ? item.fecha_creacion.toString().slice(0, 10) : '' }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Contactos Twilio por vendedora -->
    <v-dialog v-model="dialogTwilioContactos" max-width="1200px">
      <v-card>
        <v-card-title class="text-subtitle-1">
          Datos de los contactos
          <v-spacer></v-spacer>
          <v-btn icon color="black" @click="dialogTwilioContactos = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="black--text">
          <v-alert dense type="info" text class="mt-4 mb-0">
            <strong>Nota:</strong>
            <div class="text-caption mt-1">
              Unicamente se muestran los inscritos <b>DENTRO DEL PERIODO</b> de ventas, los inscritos <b>FUERA DEL
                PERIODO</b> de ventas no se muestran.
                <br/>La <b>FECHA</b> que aparece en la tabla, es la fecha en la que el prospecto se  <b>GENERÓ</b>, no es la fecha en la que se envío algún mensaje.
              </div>
          </v-alert>
          
          <v-row align="center">
            <v-col cols="12" sm="8" md="9">
              <v-autocomplete
                v-model="filtroEtiquetaSelected"
                :items="etiquetas"
                item-text="text"
                item-value="idetiquetas"
                label="Filtrar por etiqueta"
                clearable
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="text-sm-right">
              <v-btn
                small
                dark
                color="green"
                tile
                rounded
                block
                :disabled="!filterTablaContactos.length"
                @click="exportarContactosTwilio()"
              >
                <v-icon left>mdi-microsoft-excel</v-icon>
                Exportar Excel
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers3"
            :items="filterTablaContactos"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
          >

            <template v-slot:item.inscrito="{ item }">
              <v-chip :color="item.inscrito === 'SI' ? 'green' : 'red'" dark x-small>
                {{ item.inscrito || 'NO' }}
              </v-chip>
            </template>
            <template v-slot:item.idetiquetas="{ item }">
              <v-chip
                :color="getColorEtiqueta(item)"
                dark
                small
              >
                {{ getNombreEtiqueta(item) }}
              </v-chip>
            </template>
            <template v-slot:item.nombre_plantel="{ item }">
              {{ item.nombre_plantel && item.nombre_plantel !== 'SIN PLANTEL' ? item.nombre_plantel : 'SIN DATO' }}
            </template>
            <template v-slot:item.twilio="{ item }">
              <v-chip :color="item.twilio ? 'green' : 'red'" dark small @click="abrirConversacion(item)" :disabled="!item.twilio">
                {{ item.twilio | formatTelefono }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

        <!-- Diálogo de Conversación -->
    <v-dialog v-model="dialogConversacion" max-width="500px">
      <v-card class="whatsapp-container">
        <v-card-title class="whatsapp-header blue darken-3 white--text py-2 px-4 d-flex align-center">
          <v-avatar size="36" class="mr-3 grey lighten-2">
            <v-icon color="grey darken-1">mdi-account</v-icon>
          </v-avatar>
          <div>
            <div class="text-subtitle-2 font-weight-bold" style="line-height: 1.2;">{{ nombreProspectoConversacion }}</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogConversacion = false" small>
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="whatsapp-bg pa-4" style="max-height: 500px; overflow-y: auto;">
          <div v-if="cargandoConversacionTwilio" class="text-center py-10">
            <v-progress-circular indeterminate color="green" />
          </div>
          <template v-else>
          <div
            v-for="(msg, i) in conversacionSeleccionada"
            :key="'chat-' + i"
          >
            <div v-if="mostrarSeparadorDiaChat(i)" class="chat-day-separator-wrap">
              <span class="chat-day-pill">{{ etiquetaDiaChat(msg.fecha_creacion) }}</span>
            </div>
            <div class="mb-2 d-flex" :class="msg.mio == 1 ? 'justify-end' : 'justify-start'">
            <div :class="msg.mio == 1 ? 'bubble outgoing' : 'bubble incoming'" class="pa-2 px-3 elevation-1">
              <div class="bubble-text black--text font-weight-regular" v-if="msg.type == 1">{{ msg.mensaje }}</div>
              <div class="bubble-text black--text font-weight-regular" v-if="msg.type == 2">
                <v-img 
                  :src="(msg.mio == 0 ? urlFast : urlInbi) + msg.MediaUrl0" 
                  max-width="250" 
                  class="rounded-lg mb-2" 
                  style="cursor: pointer;"
                  @click="verImagen((msg.mio == 0 ? urlFast : urlInbi) + msg.MediaUrl0)"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>
              <div class="bubble-text black--text font-weight-regular" v-if="msg.type == 3" style="min-width: 200px;">
                <v-card flat class="rounded-lg pa-2 grey lighten-3 d-flex align-center" style="width: 100%;">
                  <v-btn icon small fab color="blue darken-2" @click="controlarAudio(msg, i)" class="mr-2">
                    <v-icon>{{ msg.reproduciendo ? 'mdi-pause' : 'mdi-play' }}</v-icon>
                  </v-btn>
                  <div class="flex-grow-1">
                    <v-progress-linear
                      :value="msg.progreso"
                      color="blue darken-2"
                      height="4"
                      rounded
                    ></v-progress-linear>
                    <div class="d-flex justify-space-between mt-1" style="font-size: 0.65rem;">
                      <span>{{ formatearTiempo(msg.tiempoActual || 0) }}</span>
                      <span>{{ formatearTiempo(msg.duracion || 0) }}</span>
                    </div>
                  </div>
                  <v-icon color="grey darken-1" class="ml-2">mdi-microphone</v-icon>
                </v-card>
              </div>
              <div class="bubble-text black--text font-weight-regular" v-if="msg.type == 4">
                <v-card flat class="pa-2 px-3 rounded-lg grey lighten-4 d-flex align-center" style="cursor: pointer;" @click="abrirArchivo(msg)">
                  <v-icon color="red darken-2" class="mr-2">
                    {{ esPDF(msg.MediaUrl0) ? 'mdi-file-pdf-box' : 'mdi-file-document' }}
                  </v-icon>
                  <div class="flex-grow-1 overflow-hidden" style="max-width: 150px;">
                    <div class="text-caption font-weight-bold text-truncate">{{ msg.MediaUrl0 }}</div>
                  </div>
                  <v-icon color="grey darken-1" small class="ml-2">
                    {{ esPDF(msg.MediaUrl0) ? 'mdi-eye' : 'mdi-download' }}
                  </v-icon>
                </v-card>
              </div>
              <div class="bubble-text black--text font-weight-regular" v-if="msg.type == 5">
                <video controls width="250" class="rounded-lg mb-2">
                  <source :src="(msg.mio == 0 ? urlFast : urlInbi) + msg.MediaUrl0">
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
              <div class="bubble-time text-right grey--text mt-1">
                <span>{{ formatearFechaHoraMensaje(msg.fecha_creacion) }}</span>
                <v-icon v-if="msg.mio == 1" size="14" color="blue" class="ml-1">mdi-check-all</v-icon>
              </div>
            </div>
            </div>
          </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Inscritos Prospectos -->
    <v-dialog
      v-model="dialogInscritosProspectos"
      max-width="1200px"
    >
      <v-card >
        <v-card-title primary-title class="text-subtitle-1">
          Prospectos Inscritos
        </v-card-title>
        <v-card-text>
        <v-expansion-panels
          v-model="panelVendedoras"
          multiple
        >
        <v-expansion-panel>
          <v-expansion-panel-header>Prospectos asignados a vendedoras</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card v-if="vendedoras.length" outlined class="py-4 mb-6">
                <v-card-title>
                  Resumen de contactos asignados en el período seleccionado
                </v-card-title>
    
                <v-divider class="my-2"></v-divider>
    
                <v-list >
                  <v-list-item
                    v-for="v in vendedoras"
                    :key="v.usuario_asignado"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ v.nombre_completo || 'Sin nombre' }}
                      </v-list-item-title>
    
                      <v-list-item-subtitle>
                        ID: {{ v.usuario_asignado }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
    
                    <v-list-item-action>
                      <v-chip color="primary" outlined>
                        {{ v.total_contactos }} prospectos
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
          <!-- <v-data-table
            :headers="headersProspectos"
            :items="prospectosInscritos"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
          >
            <template v-slot:item.index="{ index }">
              {{ index + 1 }}
            </template>
          </v-data-table> -->

          <v-data-table
            :headers="headersNiSucursalDialog"
            :items="prospectosInscritosSucursal"
            class="elevation-0 mt-4"
            hide-default-footer
            :items-per-page="prospectosInscritosSucursal.length"
            dense
            mobile-breakpoint="200"
          >
            <template v-slot:item.position="{ index }">
              {{ index + 1 }}
            </template>

            <template v-slot:item.no-data>
              <v-btn
                color="primary"
                @click="initialize, inicializarFastAnt"
                small
              >
                Actualizar
              </v-btn>
            </template>
            <template v-slot:item.total_completos="{ item }">
              <v-chip @click="abrirDialogoTwilioInscritos(item.completos, 'Contactos Atendidos Completos')"
              color="green" text-color="white" small>
                {{  item.total_completos }}
              </v-chip>
            </template>
            <template v-slot:item.total_incompleto="{ item }">
              <v-chip @click="abrirDialogoTwilioInscritos(item.incompletos, 'Contactos Incompletos')"
              color="grey" text-color="white" small>
              <!-- <v-chip -->
                {{  item.total_incompletos }}
              </v-chip>
            </template>

            <template v-slot:item.total_merca="{ item }">
              <v-chip @click="abrirDialogoTwilioInscritos(item.merca, 'Contactos de Merca')"
              color="purple" text-color="white" small>
              <!-- <v-chip -->
                {{  item.total_merca }}
              </v-chip>
            </template>

            <template v-slot:item.total_sucursal="{ item }">
              <!-- <v-chip -->
              <v-chip @click="abrirDialogoTwilioInscritos(item.sucursal, 'Contactos en Sucursal')"
              color="purple" text-color="white" small>
                {{  item.total_sucursal }}
              </v-chip>
            </template>
            
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark small @click="dialogInscritosProspectos = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Quien vendio -->
    <v-dialog
      v-model="dialogQuienVendio"
      max-width="1200px"
    >
      <v-card v-if="itemSucursal">
        <v-card-title primary-title class="text-subtitle-1">
          Distribución de ventas
        </v-card-title>
        <v-card-text>



          </br>
          
          <v-data-table

            :headers="headersQuienVendio"
            :items="quienVendio"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
            hide-default-footer
            :items-per-page="quienVendio.length"
          >
            <template v-slot:item.index="{ index }">
              {{ index + 1 }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark small @click="dialogQuienVendio = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


        <!-- Modal Pagos Rechazados -->
        <v-dialog
      v-model="dialogPagosRechazados"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title primary-title class="text-subtitle-1">
          {{ tipoPagosRechazados === 'fast' ? 'Pagos Rechazados FAST' : 'Pagos Rechazados INBI' }}
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersPagosRechazados"
            :items="tablaPagosRechazadosModal"
            item-key="id_ingreso"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
            :items-per-page="Math.max(tablaPagosRechazadosModal.length, 10)"
            hide-default-footer
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark small @click="dialogPagosRechazados = false">
            Cerrar
          </v-btn>
          <v-btn icon color="black" top right absolute @click="dialogPagosRechazados = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <v-dialog v-model="dialogCarga" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Cargando datos...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Twilio Detalle -->
    <v-dialog v-model="dialogTwilioDetalle" max-width="1200px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ tituloTwilioDetalle }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogTwilioDetalle = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersTwilioDetalle"
            :items="listaTwilioDetalle"
            class="elevation-1 mt-4"
            dense
            :items-per-page="10"
          >
            <template v-slot:item.idprospectos="{ item }">
              <span class="font-weight-bold">{{ item.idprospectos }}</span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogTwilioDetalle = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Preview PDF -->
    <v-dialog v-model="dialogPDFPreview" max-width="1000px">
      <v-card height="90vh" class="rounded-lg overflow-hidden">
        <v-card-title class="blue darken-3 white--text py-3 px-4 d-flex align-center">
          <v-icon dark class="mr-3">mdi-file-pdf-box</v-icon>
          <span class="text-subtitle-1 font-weight-bold">Vista previa del documento</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogPDFPreview = false" small>
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0 hide-scrollbar" style="height: calc(100% - 60px);">
          <iframe 
            v-if="dialogPDFPreview" 
            :src="urlPDFActual + '#toolbar=0'" 
            width="100%" 
            height="100%" 
            frameborder="0"
            style="border: none;"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>

  import Chart from 'chart.js/auto';

  import axios from 'axios';

  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import TablaBonoVendedoras   from '@/components/kpi/TablaBonoVendedoras.vue'
  import TablaBonoRI           from '@/components/kpi/TablaBonoRI.vue'

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  import * as am5 from '@amcharts/amcharts5';
  import * as am5xy from '@amcharts/amcharts5/xy';
  import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

  export default {

    components:{
      Alerta,
      carga,
      TablaBonoVendedoras,
      TablaBonoRI,
    },

    mixins: [ validarErrores, funcionesExcel ],

    filters: {
      formatTelefono: function (value) {
        if (!value) return 'N/A';
        const cleaned = value.slice(-10);
        if (cleaned.length === 10) {
          return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
        }
        if (cleaned.length === 11) {
          return `+${cleaned.slice(0, 1)} (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 11)}`;
        }
        return value;
      }
    },
    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },
      alertInbi: false,
      contactosListA: [],
      respuestaAlerta:false,
      loader: true,
      cargar: false,
      prospectosInscritosSucursal: [],
      dialogAlumnos:false,
      tabBono: 0,
      panelVendedoras: [0],
      dialogDetalleInscritos: false,
      tituloDetalleInscritos: '',
      itemsDetalleInscritos: [],
      loadingDetalleInscritos: false,
      inbiFilterSemana: null,
      fastFilterSemana: null,
      ciclos: [],
      cicloAct: null,
      cicloInf: null,
      cicloSup: null,
      headersDetalleInscritos: [
        { text: 'Alumno'            , value: 'alumno'           },
        { text: 'Matrícula'         , value: 'matricula'        },
        { text: 'Grupo'             , value: 'grupo'            },
        { text: 'Vendedora'         , value: 'vendedora'        },
        { text: 'Plantel'           , value: 'plantel'          },
        { text: 'Teléfono'          , value: 'celular'       },
        { text: 'Fecha Alta Prospecto',    value: 'fecha_alta_prospecto'     },
        { text: 'Fecha Inscripción'        , value: 'fecha_alta'       },
      ],

      headers: [
        { text: 'Position'               , value: 'position'     },
        { text: 'Vendedora'              , value: 'vendedora'    },
        { text: 'Puesto'                 , value: 'puesto'       },
        { text: 'Plantel'                , value: 'plantel'      },
        { text: 'Ciudad'                 , value: 'estado'       },
        { text: 'Contactos asignados'                 , value: 'total_contactos' },
        { text: 'Inscritos Totales'  , value: 'inscritosTotalesCount'    },
        { text: 'Insc. Dentro del periodo', value: 'inscritosDentroPeriodoCount' },
        { text: 'Insc. Fuera del periodo' , value: 'inscritosFueraPeriodoCount'   },
        { text: '% Conversión Semanal'   , value: 'porcentaje_conversion_periodo' },
      ],

      headersProspectos: [
        { text: '#', value: 'index', sortable: false },
        { text: 'id prospectos'    , value: 'idprospectos'    },
        { text: 'nombre completo'    , value: 'nombre_completo'    },
        { text: 'correo'    , value: 'correo'    },
        { text: 'telefono'    , value: 'telefono'    },
        { text: 'twilio'    , value: 'twilio'    },
        { text: 'fecha_creacion'    , value: 'fecha_creacion'    },
        { text: 'fecha_finalizo'    , value: 'fecha_finalizo'    },
        { text: 'nota_inicial'    , value: 'nota_inicial'    },
        { text: 'nota_rechazo'    , value: 'nota_rechazo'    },
      ],
      headers3: [
        { text: 'Inscrito'          , value: 'inscrito'    },
        { text: 'Folio'             , value: 'folio'      },
        { text: 'Nombre'            , value: 'nombre_completo' },
        { text: 'Creó'              , value: 'nombre_creo' },
        { text: 'Sucursal interés'  , value: 'nombre_plantel' },
        { text: 'Vendedora'         , value: 'nombre_vendedora' },
        // { text: 'Sistema'           , value: 'sistema'    },
        { text: 'Fecha'             , value: 'fecha_alta_prospecto_sistema'},
        { text: 'Clasificación'     , value: 'clasificacion' },
        { text: 'Total de mensajes' , value: 'total_mensajes' },
        { text: 'Mis Mensajes'      , value: 'mensajes_sistema' },
        { text: 'Mensajes Usuario'  , value: 'mensajes_usuario' },
        { text: 'Twilio'            , value: 'twilio' },
        { text: 'Etiqueta'       , value: 'idetiquetas'   },
      ],
      headersQuienVendio: [
        { text: '#'                , value: 'index', sortable: false },
        { text: 'Matrícula'        , value: 'matricula'   },
        { text: 'Alumno'           , value: 'alumno'   },
        { text: 'Quién inscribió'  , value: 'nombre_vendedora'   },
        { text: 'Tiempo transcurrido', value: 'tiempo_transcurrido'        },
      ],

      

      headersMiniReporte: [
        { text: 'Escuela'        , value: 'escuela'  },
        { text: 'Monto 1'        , value: 'monto1'  },
        { text: 'Sucursal NI'    , value: 'sucursalni'  },
        { text: 'RI Total'       , value: 'ritotal'  },
        { text: 'RI Sucursal'    , value: 'risucursal'  },
        { text: 'Diferencia Suc' , value: 'dif'  },
      ],

      headersNiSucursal: [
        { text: 'Posición'                         , value: 'position' },
        { text: 'Estado'                           , value: 'estado'   },
        { text: 'Sucursal'                         , value: 'plantel'  },
        { text: 'Total de Contactos del Periodo'   , value: 'totalContactos'  },
        // { text: 'Total Contactos Incompletos'      , value: 'total_incompleto'  },
        // { text: 'Total Contactos Completos'        , value: 'total_completos'  },
        // { text: 'Total de Contacto en Sucursal'    , value: 'total_sucursal'  },
        // { text: 'Total Contactos de Merca'         , value: 'total_merca'  },
        { text: 'Inscritos Totales'                , value: 'total'    },
        { text: 'Inscritos dentro del periodo'     , value: 'inscritos_dentro_periodo' },
        { text: 'Inscritos fuera del periodo'      , value: 'inscritos_fuera_periodo' },
        { text: 'Porcentaje de conversión del periodo', value: 'porcentaje_conversion_periodo'    },
        { text: '% para cubrir sucursal'           , value: 'porcentaje_cumplido'   },
        { text: 'Meta'                             , value: 'meta'     },
        { text: 'Faltan'                           , value: 'faltan'   },
      ],

      headersNiSucursalDialog: [
       
        { text: 'Total Contactos Completos'        , value: 'total_completos', align: 'center'  },
        { text: 'Total Contactos Incompletos'      , value: 'total_incompleto', align: 'center' },
        { text: 'Total de Contacto en Sucursal'    , value: 'total_sucursal', align: 'center'  },
        { text: 'Total Contactos de Merca'         , value: 'total_merca', align: 'center'  },
      ],

      headersAlumno: [
        { text: 'id Prospecto'   , value: 'id_prospecto'  },
        { text: 'Matricula'      , value: 'matricula'     },
        { text: 'Alumno'         , value: 'alumno'        },
        { text: 'Grupo'          , value: 'grupo'         },
        { text: 'Fecha Alta'     , value: 'fecha_alta_prospecto'    },
        { text: 'Fecha Inscripción'     , value: 'fecha_alta'    },
        { text: 'Pagado'         , value: 'pagado'        },
        { text: 'Adeudo'         , value: 'adeudo'        },
      ],

      headers2: [
        { text: 'Vendedora'              , value: 'nombre_completo'       },
        { text: 'Contactos asignados'                 , value: 'total_contactos'       },
        { text: 'Inscritos del Periodo'  , value: 'matriculas_liquidadas' },
        { text: 'Inscritos dentro del periodo', value: 'inscritos_dentro_periodo' },
        { text: 'Inscritos fuera del periodo' , value: 'inscritos_fuera_periodo'  },
        { text: '% Conversión Semanal'   , value: 'porcentaje_conversion_periodo' },
        { text: 'Mis Mensajes'      , value: 'mensajes_sistema' },
        { text: 'Mensajes Usuario'  , value: 'mensajes_usuario' },
        { text: 'Twilio'            , value: 'twilio' },
      ],

      headersSucursalSemanaFAST: [
        { text: 'Sucursal'               , value: 'plantel'       },
        { text: 'Contactos asignados'                 , value: 'total_contactos'       },
        { text: 'Inscritos del Periodo'  , value: 'matriculas_liquidadas' },
        { text: 'Inscritos dentro del periodo', value: 'inscritos_dentro_periodo' },
        { text: 'Inscritos fuera del periodo' , value: 'inscritos_fuera_periodo'  },
        { text: '% Conversión Semanal'   , value: 'porcentaje_conversion_periodo' },
      ],

      headersSucursalSemanaINBI: [
        { text: 'Sucursal'               , value: 'plantel'       },
        { text: 'Contactos asignados'                 , value: 'total_contactos'       },
        { text: 'Inscritos del Periodo'  , value: 'matriculas_liquidadas' },
        { text: 'Inscritos dentro del periodo', value: 'inscritos_dentro_periodo' },
        { text: 'Inscritos fuera del periodo' , value: 'inscritos_fuera_periodo'  },
        { text: '% Conversión Semanal'   , value: 'porcentaje_conversion_periodo' },
      ],

      headers5: [
        { text: 'Matriculas' , value: 'columna1', width: '40%', align: 'start' },
        { text: 'Semana Ant' , value: 'columna2', width: '35%', align: 'start' },
        { text: 'Semana Act' , value: 'columna3', width: '35%', align: 'start' },
      ],

      headers5Ant: [
        { text: 'Matriculas' , value: 'columna1', width: '40%', align: 'start' },
        { text: 'Semana Ant' , value: 'columna2', width: '35%', align: 'start' },
        { text: 'Semana Act' , value: 'columna3', width: '35%', align: 'start' },
      ],

      headersRI: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Plantel'          , value: 'plantel' },
        { text: 'Estado'          , value: 'estado' },
        //{ text: 'Acumulado'        , value: 'acumuladoant' },
        //{ text: 'Becados'          , value: 'becadosant' },
        //{ text: 'NI'               , value: 'niant' },
        //{ text: 'Rezagados'        , value: 'resagados' },

        //{ text: 'A. Ciclo Actual'  , value: 'totalAlumnosActuales' },
        //{ text: 'A. Irregulares'   , value: 'irregulares' },
        //{ text: 'Becados'          , value: 'becados' },
        //{ text: 'B. Certificacion' , value: 'becadoCertificacion' },
        //{ text: 'Certificacion'    , value: 'certificacion' },
        //{ text: 'Reinscribibles'   , value: 'reinscribibles' },
        //{ text: 'Acumulado'        , value: 'totalAlumnosSiguientes' },
        //{ text: 'Avance'           , value: 'totalAlumnosAyer' },
        //{ text: 'Faltantes'        , value: 'faltantes', class: 'columna2' },
        { text: '%RI'              , value: 'porcentajeAvance' },
        //{ text: 'META'             , value: 'meta_alumnos' },
        //{ text: 'META NI'          , value: 'meta_ni' },
      ],

      headersCerrados: [
			  { text: 'Vendedora',    value: 'nombre_completo' },
        { text: 'Atrasados',    value: 'atrasados'       },
			  { text: 'Nuevos',       value: 'nuevos'          },
			  { text: 'Seguimiento',  value: 'seguimiento'     },
			  { text: 'Total',        value: 'total'           },
			  { text: 'Contactos',    value: 'contactos'       },
      ],

      headersAlumnos: [
        { text: 'Matricula',    value: 'matricula'  },
        { text: 'Alumno'   ,    value: 'alumno'     },
        { text: 'Grupo'    ,    value: 'grupo'      },
        { text: 'Fecha Alta Prospecto',    value: 'fecha_alta_prospecto'     },
        { text: 'Fecha Inscripción',    value: 'fecha_alta'     },
        { text: 'Plantel'  ,    value: 'plantel'    },
        { text: 'Twilio'   ,    value: 'twilio', sortable: false },
      ],

      ciudad: [
        { text: 'Todos', value: null },
        { text: 'Monterrey', value: 1 },
        { text: 'CDMX', value: 2 },
        { text: 'GDL', value: 3 },
        { text: 'FAST', value: 4 }
      ],

      headersTwilioContactos: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Usuario', value: 'usuario' },
        { text: 'ID usuario', value: 'idusuarios' },
        { text: 'Total mensajes', value: 'total_mensajes' },
      ],

      alumnosSeleccion: [],
      dialogAlumnosSeleccion: false,

      contactosTwilioSeleccionados: [],
      dialogTwilioContactos: false,
      opZona: 'TODOS',
      baseEscuela: [],
      tituloTwilio: '',

      dataTablaFastUno:[],
      dataTablaInbiUno:[],
      dataTablaFastDos:[],

      

      desserts: [],

      tablaFast:[],
      tablaInbi:[],

      fechaini:null,
      fechafin:null,
      totalInbi:0,
      totalFast:0,

      fechaini:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      prospectosInscritos: [],
      vendedoras: [],
      quienVendio: [],
      dialogInscritosProspectos: false,
      dialogQuienVendio: false,

      fechaini:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      nuevasMatriculas:[],
      vendedorasActuales:[],
      vendedorasActualesFiltered:[],
      encabezados: null,
      encabezadosAnt: null,
      encabezadosFastAnt: null,
      encabezados_ant: null,
      escuela: 1,
      
      datosTablaHeaders5:[],
      datosTablaHeaders6:[],

      datosTablaHeaders5Ant:[],
      datosTablaHeaders6Ant:[],

      vendedorasActualesFAST:[],
      vendedorasActualesFASTFiltered:[],
      encabezadosFast: null,
			encabezados_antFast: null,

      miniReporte:[
        { escuela: 'Fast', monto1: 0, sucursalni: '', ritotal: 0, risucursal: 0, dif: '' },
        { escuela: 'Inbi', monto1: 0, sucursalni: '', ritotal: 0, risucursal: 0, dif: '' }
      ],

			reporteFast:[],
			reporteInbi:[],

      fecha_inicio:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fecha_final:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      ciclo: null,

      resultadoRi: [],
      resultadoRiFiltro: [],

      tablaVentasCiclo:[],
      tablaVentaCicloInbi : false,
      dialogVentasCiclo: false,

      dialogVendedorasSemana: false,
			dataTablaSemana:  [],
			tituloSemana: '',

      fast: null,
      inbi: null,
      alumnos:[],

      id_ciclo: null,
      id_ciclo_relacionado: null,

      grafica_data: [],

      root: null,

      inbiFilter: '',
      contactosInvisibles: 0,
      inscritosInvisibles: 0,
      

      metas: [],
      segundaSemanaCicloActual: '',
      segundoDomingoCicloProximo: '',
      restanDias: null,
      itemSucursal: null,
      totalInscritos: [],
      ingresosRechazados: [],
      inscritosListDentro: [],
      inscritosListFuera: [],
      dataTotalesInbi: [],
      dataTotalesFast: [],
      headersPagosRechazados: [
        { text: 'ID Ingreso', value: 'id_ingreso' },
        { text: 'Nombre (usuario)', value: 'nombre_completo' },
        { text: 'Fecha pago', value: 'fecha_pago' },
        { text: 'Matrícula', value: 'matricula' },
        { text: 'Alumno', value: 'nombre_completo_alumno' },
        { text: 'Grupo', value: 'grupo' },
        { text: 'Ciclo', value: 'ciclo' },
      ],

      tipoPagosRechazados: '',
      dialogPagosRechazados: false,
      filtroEtiquetaSelected: null,
      etiquetas: [
        { idetiquetas: 1, text: 'PENDIENTE DE PAGO', color: '#FF0000' },
        { idetiquetas: 2, text: 'CLIENTE POTENCIAL', color: '#FFD700' },
        { idetiquetas: 3, text: 'EXAMEN DE UBICACION', color: '#1E90FF' },
        { idetiquetas: 4, text: 'PAGO PARCIAL', color: '#FF6D08' },
        { idetiquetas: 5, text: 'INSCRITO', color: '#48D91C' },
        { idetiquetas: 6, text: 'VENTANA DE TIEMPO', color: '#4A148C' },
        { idetiquetas: 7, text: 'SPAM', color: '#000000' },
        { idetiquetas: 8, text: 'CON CITA AGENDADA', color: '#E91E63' },
        { idetiquetas: 9, text: 'CLIENTE NO CONTESTA', color: '#9C27B0' },
        { idetiquetas: 10, text: 'NO INTERESADO', color: '#607D8B' },
        { idetiquetas: 11, text: 'EXAMEN ENVIADO', color: '#00BCD4' },
        { idetiquetas: 12, text: 'NUEVO', color: '#4CAF50' },
        { idetiquetas: 13, text: 'PRIMER CONTACTO', color: '#FF9800' },
        { idetiquetas: 14, text: 'LLAMADA AGENDADA', color: '#3F51B5' },
        { idetiquetas: 15, text: 'NUEVO WEB', color: '#009688' },
      ],
      // Twilio Detalle
      dialogTwilioDetalle: false,
      listaTwilioDetalle: [],
      tituloTwilioDetalle: '',
      headersTwilioDetalle: [
        { text: 'ID', value: 'idprospectos' },
        { text: 'Alumno', value: 'nombre_completo' },
        { text: 'Twilio', value: 'twilio' },
        { text: 'Fecha Creación', value: 'fecha_creacion' },
        { text: 'Vendedora', value: 'nombre_vendedora' }
      ],
      dialogConversacion: false,
      cargandoConversacionTwilio: false,
      conversacionSeleccionada: [],
      nombreProspectoConversacion: '',
      urlFast :'https://testfast.club/imagenes-whatsapp/',
			urlInbi: 'https://escuelakpi.club/imagenes-whatsapp/',
      audioElemento: null,
      audioEnReproduccionIndex: -1,
      dialogPDFPreview: false,
      urlPDFActual: '',
    }),

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado', 'getEscuela','drawer2','getEstatusLlamada','getNuevosProspectos']),

      dataTablaInbiUnoFiltered() {
        if (this.dataTablaInbiUno.length === 0) return [];

        const filtered = this.dataTablaInbiUno.filter(i => {
          i.totalContactos = i.total_completos + i.total_incompletos + i.total_sucursal + i.total_merca;
          return i.plantel !== 'Total'
        });

        return [...filtered];
      },

      dataTablaFastUnoFiltered() {
        if (this.dataTablaFastUno.length === 0) return [];

        // const filtered = this.dataTablaFastUno.filter(i => i.plantel !== 'Total');
        const filtered = this.dataTablaFastUno.filter(item => {
          if (item.plantel !== 'Total') {
            item.totalContactos = item.total_completos + item.total_incompletos + item.total_sucursal + item.total_merca;
            return item;
          }
        })
        return [...filtered];
      },

      dataTablaSemanaFiltered() {

        if( this.dataTablaSemana.length ) {
          const r = this.traducirEstado( this.inbiFilter )
          let dataTable = this.dataTablaSemana.filter(el => ![ 87].includes(el.id_usuario));

          
          if(r) {
            //this.dataTablaSemanaFiltered
            //this.dataTablaSemanaFiltered = [...this.dataTablaSemanaFiltered, this.calcularTotal(this.dataTablaSemanaFiltered)];
            //console.log( this.dataTablaSemana.filter(item => item.estado === r) )
            return dataTable.filter(item => item.estado === r);
          }
          else {
            return dataTable
          }
        }
        return [];
      },

      dataTablaInbiFiltered() {
        if( this.vendedorasActualesFiltered && this.vendedorasActualesFiltered.length > 0 ) {
           const r = this.inbiFilterSemana ? this.traducirEstado(this.inbiFilterSemana) : null;
           const filtrado = this.vendedorasActualesFiltered.filter((el) => {
              const pasaFiltroCiudad = r ? el.estado === r : true;
              return pasaFiltroCiudad && el.nombre_completo !== 'TOTAL';
           });

           const agrupado = {};
           filtrado.forEach(el => {
              const sucursal = el.plantel || 'SIN SUCURSAL';
              if(!agrupado[sucursal]) {
                 agrupado[sucursal] = {
                    plantel: sucursal,
                    nombre_completo: sucursal, // Necesario para modales hijos
                    total_contactos: 0,
                    matriculas_liquidadas: 0,
                    inscritos_dentro_periodo: 0,
                    inscritos_fuera_periodo: 0,
                    contactos_twilio_lista: [],
                    inscritos_dentro_list: [],
                    inscritos_fuera_list: [],
                    nuevasMatriculas: []
                 };
              }
              agrupado[sucursal].total_contactos += (el.total_contactos || 0);
              agrupado[sucursal].matriculas_liquidadas += (el.matriculas_liquidadas || 0);
              agrupado[sucursal].inscritos_dentro_periodo += (el.inscritos_dentro_periodo || 0);
              agrupado[sucursal].inscritos_fuera_periodo += (el.inscritos_fuera_periodo || 0);
              
              if (el.contactos_twilio_lista) agrupado[sucursal].contactos_twilio_lista.push(...el.contactos_twilio_lista);
              if (el.inscritos_dentro_list) agrupado[sucursal].inscritos_dentro_list.push(...el.inscritos_dentro_list);
              if (el.inscritos_fuera_list) agrupado[sucursal].inscritos_fuera_list.push(...el.inscritos_fuera_list);
              if (el.nuevasMatriculas) agrupado[sucursal].nuevasMatriculas.push(...el.nuevasMatriculas);
           });

           return Object.values(agrupado).map(item => {
              item.porcentaje_conversion_periodo = item.total_contactos > 0 
                  ? (((item.inscritos_dentro_periodo + item.inscritos_fuera_periodo) / item.total_contactos) * 100).toFixed(2)
                  : '0.00';
              return item;
           }).sort((a,b) => b.total_contactos - a.total_contactos);
        }
        return [];
      },

      dataTablaFastFiltered() {
        if( this.vendedorasActualesFASTFiltered && this.vendedorasActualesFASTFiltered.length > 0 ) {
           const r = this.fastFilterSemana ? this.traducirEstado(this.fastFilterSemana) : null;
           const filtrado = this.vendedorasActualesFASTFiltered.filter((el) => {
              const pasaFiltroCiudad = r ? el.estado === r : true;
              return pasaFiltroCiudad && el.nombre_completo !== 'TOTAL';
           });

           const agrupado = {};
           filtrado.forEach(el => {
              const sucursal = el.plantel || 'SIN SUCURSAL';
              if(!agrupado[sucursal]) {
                 agrupado[sucursal] = {
                    plantel: sucursal,
                    nombre_completo: sucursal, // Necesario para modales hijos
                    total_contactos: 0,
                    matriculas_liquidadas: 0,
                    inscritos_dentro_periodo: 0,
                    inscritos_fuera_periodo: 0,
                    contactos_twilio_lista: [],
                    inscritos_dentro_list: [],
                    inscritos_fuera_list: [],
                    nuevasMatriculas: []
                 };
              }
              agrupado[sucursal].total_contactos += (el.total_contactos || 0);
              agrupado[sucursal].matriculas_liquidadas += (el.matriculas_liquidadas || 0);
              agrupado[sucursal].inscritos_dentro_periodo += (el.inscritos_dentro_periodo || 0);
              agrupado[sucursal].inscritos_fuera_periodo += (el.inscritos_fuera_periodo || 0);
              
              if (el.contactos_twilio_lista) agrupado[sucursal].contactos_twilio_lista.push(...el.contactos_twilio_lista);
              if (el.inscritos_dentro_list) agrupado[sucursal].inscritos_dentro_list.push(...el.inscritos_dentro_list);
              if (el.inscritos_fuera_list) agrupado[sucursal].inscritos_fuera_list.push(...el.inscritos_fuera_list);
              if (el.nuevasMatriculas) agrupado[sucursal].nuevasMatriculas.push(...el.nuevasMatriculas);
           });

           return Object.values(agrupado).map(item => {
              item.porcentaje_conversion_periodo = item.total_contactos > 0 
                  ? (((item.inscritos_dentro_periodo + item.inscritos_fuera_periodo) / item.total_contactos) * 100).toFixed(2)
                  : '0.00';
              return item;
           }).sort((a,b) => b.total_contactos - a.total_contactos);
        }
        return [];
      },

      avanceActualesFast() {
        if( this.dataTablaFastUno.length > 0 ) {
          return (( this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].total / this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].meta  )*100)
        }
        else {
          return 0
        }
      },

      totalVentasFast() {
        if( this.dataTablaFastUno.length > 0 ) {
          return this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].total
        }
        else {
          return 0
        }
      },

      totalVentasInbi() {
        if( this.dataTablaInbiUno.length > 0 ) {
          return this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].total
        }
        else {
          return 0
        }
      },

      metaFast() {
        if( this.dataTablaFastUno.length > 0 ) {
          return this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].meta
        }
        else {
          return 0
        }
      },

      metaInbi() {
        if( this.dataTablaInbiUno.length > 0 ) {
          return this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].meta
        }
        else {
          return 0
        }
      },

      avanceActualesInbi() {
        if( this.dataTablaInbiUno.length > 0 ) {
          return (( this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].total / this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].meta  )*100)
        }
        else {
          return 0
        }
      },

      ventasCambiosFast(){
        if( this.dataTablaFastUno.length > 0 ) {
          console.log( this.dataTablaFastUno )
          return this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].total_fuera_ciclo
        }
        else {
          return 0
        }
      },

      ventasCambiosInbi(){
        if( this.dataTablaInbiUno.length > 0 ) {
          return this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].total_fuera_ciclo
        }
        else {
          return 0
        }
      },

      filterTablaContactos() {
        let data = this.contactosTwilioSeleccionados || [];

        if (this.opZona !== 'TODOS') {
          data = data.filter(el => el.sistema === this.opZona);
        }

        if (this.filtroEtiquetaSelected) {
          data = data.filter(el => {
            const etiquetaEfectiva = el.inscrito === 'SI' ? 5 : (el.idetiquetas ? Number(el.idetiquetas) : 12);
            return etiquetaEfectiva === Number(this.filtroEtiquetaSelected);
          });
        }

        return data;
      },

      totalTwilioCompleto() {
        return this.filterTablaContactos.filter(el => el.clasificacion === 'TWILIO COMPLETO').length;
      },

      totalTwilioIncompleto() {
        return this.filterTablaContactos.filter(el => el.clasificacion === 'TWILIO INCOMPLETO').length;
      },

      totalMerca() {
        return this.filterTablaContactos.filter(el => el.clasificacion === 'MERCADOTECNIA').length;
      },

      totalSucursal() {
        return this.filterTablaContactos.filter(el => el.clasificacion === 'SUCURSAL').length;
      },

      totalGeneral() {
        return this.filterTablaContactos.length;
      },

      ingresosRechazadosInbi() {
        return (this.ingresosRechazados || []).filter(r => r.esInbi === 1);
      },

      ingresosRechazadosFast() {
        return (this.ingresosRechazados || []).filter(r => r.esInbi !== 1);
      },

      tablaPagosRechazadosModal() {
        if (this.tipoPagosRechazados === 'inbi') return this.ingresosRechazadosInbi;
        if (this.tipoPagosRechazados === 'fast') return this.ingresosRechazadosFast;
        return [];
      },

    },

    async created () {
      await this.initialize4()


    },


    watch:{
      dataTablaSemana( value ){
        console.log('watch')
        console.log( value )
      },
      dialogConversacion(val) {
        if (!val) {
          this.detenerAudioActual();
        }
      }
    },

    methods: {
      usuarioWhatsappDesdeTelefono(raw) {
        const s = String(raw == null ? '' : raw).trim();
        if (/^whatsapp:/i.test(s)) return s;
        const d = s.replace(/\D/g, '');
        if (!d) return '';
        if (d.length === 10) return 'whatsapp:+521' + d;
        if (d.startsWith('521') && d.length >= 12) return 'whatsapp:+' + d;
        if (d.startsWith('52') && d.length >= 11 && !d.startsWith('521')) return 'whatsapp:+52' + d.slice(2);
        if (d.startsWith('1') && d.length === 11) return 'whatsapp:+521' + d.slice(1);
        return 'whatsapp:+' + d;
      },

      escuelaTwilioParaKpiChat(item) {
        const pick = (v) => {
          const n = Number(v);
          return n === 1 || n === 2 ? n : null;
        };
        let e = pick(item.twilio_escuela);
        if (e != null) return e;
        e = pick(item.escuela);
        if (e != null) return e;
        e = pick(item.unidad_negocio);
        if (e != null) return e;
        return null;
      },

      async abrirConversacion(item) {
        this.detenerAudioActual();
        if (!item || !item.twilio) return;
        const usuario = this.usuarioWhatsappDesdeTelefono(item.twilio);
        if (!usuario) {
          this.validarError('No se pudo determinar el identificador de WhatsApp para este contacto.');
          return;
        }
        const escuela = this.escuelaTwilioParaKpiChat(item);
        if (escuela == null) {
          this.validarError('No se pudo determinar la escuela de este contacto.');
          return;
        }
        this.cargandoConversacionTwilio = true;
        this.dialogConversacion = true;
        this.conversacionSeleccionada = [];
        this.nombreProspectoConversacion = item.twilio ? this.$options.filters.formatTelefono(item.twilio) : '';
        try {
          const response = await this.$http.post('twilio.chats.unico', {
            modo: true,
            escuela,
            usuario,
          });
          const conversacion = response.data.conversacionCompleta || [];
          this.conversacionSeleccionada = conversacion.map((m) => {
            if (m.type == 3) {
              this.$set(m, 'reproduciendo', false);
              this.$set(m, 'progreso', 0);
              this.$set(m, 'tiempoActual', 0);
              this.$set(m, 'duracion', 0);
            }
            return m;
          });
        } catch (error) {
          const msg =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : error.message || 'Error al cargar la conversación';
          this.validarError(msg);
        } finally {
          this.cargandoConversacionTwilio = false;
        }
      },

      controlarAudio(msg, index) {
        const url = (msg.mio == 0 ? this.urlFast : this.urlInbi) + msg.MediaUrl0;

        // Si es el mismo audio que está sonando, alternar Play/Pause
        if (this.audioEnReproduccionIndex === index && this.audioElemento) {
          if (msg.reproduciendo) {
            this.audioElemento.pause();
            msg.reproduciendo = false;
          } else {
            this.audioElemento.play();
            msg.reproduciendo = true;
          }
          return;
        }

        // Si hay otro audio sonando, detenerlo
        this.detenerAudioActual();

        // Crear nuevo elemento de audio
        this.audioElemento = new Audio(url);
        this.audioEnReproduccionIndex = index;
        msg.reproduciendo = true;

        this.audioElemento.addEventListener('loadedmetadata', () => {
          this.$set(msg, 'duracion', this.audioElemento.duration);
        });

        this.audioElemento.addEventListener('timeupdate', () => {
          this.$set(msg, 'tiempoActual', this.audioElemento.currentTime);
          this.$set(msg, 'progreso', (this.audioElemento.currentTime / this.audioElemento.duration) * 100);
        });

        this.audioElemento.addEventListener('ended', () => {
          msg.reproduciendo = false;
          msg.progreso = 0;
          msg.tiempoActual = 0;
          this.audioEnReproduccionIndex = -1;
          this.audioElemento = null;
        });

        this.audioElemento.play();
      },

      detenerAudioActual() {
        if (this.audioElemento) {
          this.audioElemento.pause();
          if (this.audioEnReproduccionIndex !== -1 && this.conversacionSeleccionada[this.audioEnReproduccionIndex]) {
            this.conversacionSeleccionada[this.audioEnReproduccionIndex].reproduciendo = false;
          }
          this.audioElemento = null;
          this.audioEnReproduccionIndex = -1;
        }
      },

      formatearTiempo(segundos) {
        if (!segundos) return '0:00';
        const mins = Math.floor(segundos / 60);
        const secs = Math.floor(segundos % 60);
        return mins + ':' + (secs < 10 ? '0' : '') + secs;
      },

      claveDiaLocalMensaje(fecha) {
        if (!fecha) return '';
        const d = new Date(fecha);
        if (isNaN(d.getTime())) return '';
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      },

      mostrarSeparadorDiaChat(i) {
        const list = this.conversacionSeleccionada;
        if (!list || !list.length) return false;
        const cur = list[i];
        if (!cur || !cur.fecha_creacion) return false;
        if (i === 0) return true;
        const prev = list[i - 1];
        if (!prev || !prev.fecha_creacion) return true;
        return this.claveDiaLocalMensaje(cur.fecha_creacion) !== this.claveDiaLocalMensaje(prev.fecha_creacion);
      },

      etiquetaDiaChat(fecha) {
        if (!fecha) return '';
        const d = new Date(fecha);
        if (isNaN(d.getTime())) return '';
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        const ayer = new Date(hoy);
        ayer.setDate(ayer.getDate() - 1);
        const ref = new Date(d);
        ref.setHours(0, 0, 0, 0);
        if (ref.getTime() === hoy.getTime()) return 'Hoy';
        if (ref.getTime() === ayer.getTime()) return 'Ayer';
        const raw = d.toLocaleDateString('es-MX', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
        return raw.charAt(0).toUpperCase() + raw.slice(1);
      },

      formatearFechaHoraMensaje(fecha) {
        if (!fecha) return '';
        const d = new Date(fecha);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
      },

      verImagen(url) {
        if (!url) return;
        window.open(url, '_blank');
      },

      verPDF(url) {
        if (!url) return;
        this.urlPDFActual = url;
        this.dialogPDFPreview = true;
      },

      esPDF(url) {
        if (!url) return false;
        return url.toLowerCase().endsWith('.pdf');
      },

      abrirArchivo(msg) {
        const url = (msg.mio == 0 ? this.urlFast : this.urlInbi) + msg.MediaUrl0;
        if (this.esPDF(msg.MediaUrl0)) {
          this.verPDF(url);
        } else {
          // Descargar
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', msg.MediaUrl0);
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },

      getColorEtiqueta({idetiquetas, inscrito}) {
        const etiquetas = this.etiquetas || [];
        const etiqueta = etiquetas.find(e => e.idetiquetas === idetiquetas);
        if(inscrito == 'SI'){
          return '#48D91C';
        }
        if(etiqueta){
          return etiqueta.color;
        }
        return '#4CAF50';
      },

      getNombreEtiqueta({idetiquetas, inscrito}) {
        const etiquetas = this.etiquetas || [];
        const etiqueta = etiquetas.find(e => e.idetiquetas === idetiquetas);
        if(inscrito == 'SI'){
          return 'INSCRITO';
        }
        if(etiqueta){
          return etiqueta.text;
        }
        return 'NUEVO';
      },

      // sendToTwilio(item) {
      //   if (item.twilio) {
      //     sessionStorage.setItem('twilioTmp', item.twilio.slice(-10));
      //     const ruta = this.alertInbi ? '/twilio-unificado' : '/twiliofast';
      //     const { href } = this.$router.resolve(ruta);
      //     window.open(href, '_blank');
      //   }
      // },
      formatFecha(fecha) {
        if (!fecha) return '';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-MX', { year: 'numeric', month: '2-digit', day: '2-digit' });
      },

      abrirTotalesContactosSemana(items) {
        // const items = this.dataTablaSemanaFiltered || [];
        this.abrirDialogoTwilio({
          contactos_twilio_lista: items.flatMap(i => i.contactos_twilio_lista || []),
          inscritos_dentro_list:  items.flatMap(i => i.inscritos_dentro_list  || []),
          inscritos_fuera_list:   items.flatMap(i => i.inscritos_fuera_list   || []),
          vendedora: 'TODOS'
        });
      },

      async abrirDetalleInscritos(lista, titulo) {
        console.log(lista);
        
        this.tituloDetalleInscritos = titulo || 'Inscritos';
        this.itemsDetalleInscritos = [];
        this.dialogDetalleInscritos = true;

        if (!lista || lista.length === 0) return;

        this.loadingDetalleInscritos = true;
        try {
          // const auth = { headers: { 'Authorization': `Bearer ${this.$store.getters.getToken}` } };
          // const res = await axios.post(this.$store.getters.getBacth + '/kpi.inscritos.detalle', { ids }, auth);
          this.itemsDetalleInscritos = lista;
        } catch (error) {
          console.error("Error al obtener detalle de inscritos: ", error);
        } finally {
          this.loadingDetalleInscritos = false;
        }
      },

    	async initialize4(){
        this.cargar = true
        try {
          await Promise.all([
            this.getSemanaCicloActualYProximo(),
            this.getIngresosRechazados(),
            this.initialize(),
          ])
          await Promise.all([
            this.getCiclosActivos(),
            this.datosDeRI(),
            this.riSucursalesMonto(),
          ])
          this.construirTablaVentasCiclo(true, null);
          this.construirTablaVentasCiclo(false, null);
        } catch (e) {
          console.warn('[VentasMomento] initialize4:', e)
        } finally {
          this.cargar = false
          this.$nextTick(() => {
            if (this.$refs.tablaBonoVendedoras && this.$refs.tablaBonoVendedoras.cargarMetas) {
              this.$refs.tablaBonoVendedoras.cargarMetas()
            }
          })
        }
    	},

      abrirVentasCiclo(esInbi) {
        this.alertInbi = esInbi;
        this.tablaVentaCicloInbi = esInbi;
        this.inbiFilter = null;
        this.construirTablaVentasCiclo(esInbi, null);
        this.dialogVentasCiclo = true;
      },

      /**
       * Mapa id prospecto → contacto Twilio (tolera number/string).
       */
      _mapaContactosTwilioPorProspecto(contactosTwilioLista) {
        const m = new Map();
        const lista = contactosTwilioLista || [];
        for (let i = 0; i < lista.length; i++) {
          const c = lista[i];
          if (!c || typeof c !== 'object') continue;
          const raw = c.idprospectos;
          if (raw == null || raw === '') continue;
          m.set(raw, c);
          const n = Number(raw);
          if (!Number.isNaN(n)) m.set(n, c);
          m.set(String(raw), c);
        }
        return m;
      },

      _contactoTwilioPorProspecto(mapa, idProspecto) {
        if (idProspecto == null || idProspecto === '') return null;
        return (
          mapa.get(idProspecto) ||
          mapa.get(Number(idProspecto)) ||
          mapa.get(String(idProspecto)) ||
          null
        );
      },

      /**
       * Une filas de inscripción (totalA) con el mismo contacto que usa «Datos de los contactos», para chip Twilio y conversación.
       */
      fusionarInscripcionesConTwilio(inscripciones, contactosTwilioLista) {
        const mapa = this._mapaContactosTwilioPorProspecto(contactosTwilioLista);
        const rows = inscripciones || [];
        const out = [];
        for (let i = 0; i < rows.length; i++) {
          const row = rows[i];
          if (!row || typeof row !== 'object') continue;
          const idIns =
            row.id_prospecto != null && row.id_prospecto !== ''
              ? row.id_prospecto
              : row.idprospectos;
          const ct = this._contactoTwilioPorProspecto(mapa, idIns);
          let tel = null;
          const ta =
            row.twilio_asignado != null && String(row.twilio_asignado).trim() !== ''
              ? String(row.twilio_asignado).trim()
              : '';
          const tp =
            row.twilio_desde_prospecto != null && String(row.twilio_desde_prospecto).trim() !== ''
              ? String(row.twilio_desde_prospecto).trim()
              : '';
          if (ta) {
            tel = ta;
          } else if (tp) {
            tel = tp;
          } else if (ct) {
            if (ct.twilio != null && ct.twilio !== '') tel = ct.twilio;
            else if (ct.telefono != null && ct.telefono !== '') tel = ct.telefono;
          }
          const twilioEscuela =
            ct && ct.escuela != null && ct.escuela !== ''
              ? Number(ct.escuela)
              : row.unidad_negocio != null && row.unidad_negocio !== ''
                ? Number(row.unidad_negocio)
                : null;
          out.push(
            Object.assign({}, row, {
              twilio: tel,
              conversacion: [],
              total_mensajes: ct && ct.total_mensajes != null ? ct.total_mensajes : 0,
              twilio_escuela: twilioEscuela,
            })
          );
        }
        return out;
      },

      /** Modal «Alumnos»: tabla de inscripciones + Twilio (ventas por ciclo por vendedora). */
      openDialogAlumnosVentasCiclo(item, listaInscripciones) {
        if (!item) return;
        const lista = listaInscripciones || [];
        try {
          this.alumnos = this.fusionarInscripcionesConTwilio(lista, item.contactos_twilio_lista);
        } catch (err) {
          console.error('fusionarInscripcionesConTwilio', err);
          this.alumnos = lista.slice ? lista.slice() : lista;
        }
        this.dialogAlumnos = true;
      },

      abrirDialogAlumnosInscritosTotalesVentasCiclo(item) {
        this.openDialogAlumnosVentasCiclo(item, item.inscritosTotales);
      },

      abrirDialogAlumnosInscritosDentroPeriodoVentasCiclo(item) {
        this.openDialogAlumnosVentasCiclo(item, item.inscritosDentroPeriodo);
      },

      abrirDialogoTwilio(item) {
        // console.log("item",item);
        
        this.contactosTwilioSeleccionados = item.contactos_twilio_lista || [];
        const desdeDentro = item.inscritos_dentro_list || item.inscritosDentroPeriodo || [];
        const desdeFuera = item.inscritos_fuera_list || item.inscritosFueraPeriodo || [];
        this.contactosListA = [...desdeDentro, ...desdeFuera];

        

        const normalizar = (text) => text ? text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "").trim() : '';

        const mapCelulares = new Map(this.contactosListA.map(el => [el.celular ? String(el.celular).replace(/\D/g, '').slice(-10) : '', el]).filter(i => i[0]));

        const mapProspectos = new Map(this.contactosListA.map(el => [el.id_prospecto || el.idprospectos, el]).filter(i => i[0]));
        const mapNombres = new Map(this.contactosListA.map(el => [normalizar(el.alumno || el.nombre), el]).filter(i => i[0]));

        this.contactosTwilioSeleccionados = this.contactosTwilioSeleccionados.map(el => {
          let telNorm = el.telefono ? String(el.telefono).replace(/\D/g, '').slice(-10) : '';
          let nombreNorm = normalizar(el.nombre_completo);
          
          // El backend ya calcula esta_inscrito (1 o true). También validamos contra listas locales.
          const matchLocal = 
          (el.id_prospecto && mapProspectos.has(el.id_prospecto)) ||
            (el.idprospectos && mapProspectos.has(el.idprospectos)) || 
            (telNorm && mapCelulares.has(telNorm)) ||
            (nombreNorm && mapNombres.has(nombreNorm));

          el.esta_inscrito = (el.esta_inscrito == 1 || el.esta_inscrito === true || matchLocal);
          return el;
        });
        // Cargar baseEscuela si está vacía
        if (this.baseEscuela.length === 0) {
          this.baseEscuela = [
            { zona: 'TWILIO CDMX' },
            { zona: 'TWILIO GUADALAJARA' },
            { zona: 'TWILIO MONTERREY' },
            { zona: 'TWILIO CRM INBI' },
            { zona: 'TWILIO FAST' },
            { zona: 'TWILIO CRM FAST' },
            { zona: 'SUCURSAL EXTERNO' },
            { zona: 'TODOS' }
          ];
        }

        // Clasificar contactos para los contadores del diálogo
        for (const i in this.contactosTwilioSeleccionados) {
          const { nombre_completo, idpuesto } = this.contactosTwilioSeleccionados[i];

          if (nombre_completo && nombre_completo.match('TWILIO COMPLETO')) {
            this.contactosTwilioSeleccionados[i]['clasificacion'] = 'TWILIO COMPLETO';
          } else if (nombre_completo && nombre_completo.match('TWILIO INCOMPLETO')) {
            this.contactosTwilioSeleccionados[i]['clasificacion'] = 'TWILIO INCOMPLETO';
          } else if (nombre_completo && !nombre_completo.match('TWILIO') && [25, 48, 49, 54, 62, 74, 97, 101].includes(idpuesto)) {
            this.contactosTwilioSeleccionados[i]['clasificacion'] = 'MERCADOTECNIA';
          } else {
            this.contactosTwilioSeleccionados[i]['clasificacion'] = 'SUCURSAL';
          }
        }

        this.tituloTwilio = `Contactos Twilio - ${item.vendedora || ''}`;
        this.dialogTwilioContactos = true;
      },

      filtroPorZona(zona) {
        return (this.contactosTwilioSeleccionados || []).filter(el => el.sistema === zona).length;
      },

      crearGrafica( ){

        let root     = am5.Root.new(this.$refs.chartdiv);

        root.setThemes([
          am5themes_Animated.new(root)
        ]);


        // Create chart
        // https://www.amcharts.com/docs/v5/charts/xy-chart/
        let chart = root.container.children.push(am5xy.XYChart.new(root, {
          panX: false,
          panY: false,
          wheelX: "none",
          wheelY: "none",
          paddingLeft: 0
        }));

        // Add cursor
        // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
        let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
        cursor.lineY.set("visible", false);

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
        let xRenderer = am5xy.AxisRendererX.new(root, {
          minGridDistance: 30,
          minorGridEnabled: true
         });

        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
          maxDeviation: 0,
          categoryField: "name",
          renderer: xRenderer,
          tooltip: am5.Tooltip.new(root, {})
        }));

        xRenderer.grid.template.set("visible", false);

        let yRenderer = am5xy.AxisRendererY.new(root, {});
        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
          maxDeviation: 0,
          min: 0,
          extraMax: 0.1,
          renderer: yRenderer
        }));

        yRenderer.grid.template.setAll({
          strokeDasharray: [2, 2]
        });

        // Create series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        let series = chart.series.push(am5xy.ColumnSeries.new(root, {
          name: "Series 1",
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "value",
          sequencedInterpolation: true,
          categoryXField: "name",
          tooltip: am5.Tooltip.new(root, { dy: -25, labelText: "{valueY}" })
        }));


        series.columns.template.setAll({
          cornerRadiusTL: 5,
          cornerRadiusTR: 5,
          strokeOpacity: 0
        });

        series.columns.template.adapters.add("fill", (fill, target) => {
          return chart.get("colors").getIndex(series.columns.indexOf(target));
        });

        series.columns.template.adapters.add("stroke", (stroke, target) => {
          return chart.get("colors").getIndex(series.columns.indexOf(target));
        });

        // Set data
        let data = []
        // [{
        //   name: "24fwfwef",
        //   value: 100,
        //   src: "https://thumbs.dreamstime.com/b/muchacha-sonriente-del-recepcionista-28847483.jpg"
        // }]

        for( const i in this.grafica_data ){

          const { nombre_completo, matriculas_liquidadas } = this.grafica_data[i]

          data.push({
            name: nombre_completo,
            value: matriculas_liquidadas,
            src: "https://thumbs.dreamstime.com/b/muchacha-sonriente-del-recepcionista-28847483.jpg"
          })

        }

        series.bullets.push(function (root, series, dataItem) {
          return am5.Bullet.new(root, {
            locationY: 1,
            sprite: am5.Picture.new(root, {
              width: 50,
              height: 50,
              centerX: am5.p50,
              centerY: am5.p50,
              src: dataItem.dataContext.src // ✅ importante
            })
          });
        });

        // console.log("🖼 Bullet para:", dataItem.dataContext.name, dataItem.dataContext.src);

        xAxis.data.setAll(data);
        series.data.setAll(data);

        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        console.log( 10 )

        series.appear(1000);
        chart.appear(1000, 100);

        this.root = root
      },

    	initialize () {
        this.cargar    = true
        var payload = { fechaini: this.fechaini, escuela: this.escuela }

        return this.$http.post('kpi.ventasmomento', payload ).then(response=>{

          this.restanDias = response.data.diasRestantes

          this.tablaFast        = response.data.vendedorasFast
          this.tablaInbi        = response.data.vendedorasInbi
          this.totalFast        = response.data.totalFast
          this.Ventas        = response.data.totalInbi

          this.metas            = response.data.metas

        	// caoichovnonvavvv
        	this.encabezados            = response.data.encabezados
        	this.encabezados_ant        = response.data.encabezados
        	this.vendedorasActuales     = response.data.vendedorasActuales
        	this.vendedorasActualesFiltered     = response.data.vendedorasActuales
          //console.log( 'Ventas semana INBI' )
          //console.log( this.vendedorasActualesFiltered )
          
        	this.vendedorasActualesFAST = response.data.vendedorasActualesFAST
        	this.vendedorasActualesFASTFiltered = response.data.vendedorasActualesFAST
          //console.log( 'Ventas semana FAST' )
          //console.log( this.vendedorasActualesFASTFiltered )
        	this.encabezadosFast        = response.data.encabezadosFast
        	this.encabezados_antFast    = response.data.encabezadosFast

          this.id_ciclo               = response.data.id_ciclo
          this.id_ciclo_relacionado   = response.data.id_ciclo_relacionado
          this.ciclo                  = response.data.ciclo

          
          this.datosTablaHeaders5 = [
            {
              columna1: 'Nvas. Liq. FAST',
              columna2: ` ${ this.encabezadosFast.matriculas_liquidadasSemAnt} => ${ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.encabezadosFast.matriculas_liquidadas_montoSemAnt ) }`,
              columna3: ` ${ this.encabezadosFast.matriculas_liquidadas} => ${ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.encabezadosFast.matriculas_liquidadas_monto ) }`,
              columna5: this.encabezadosFast.matriculas_liquidadasSemAnt,
              columna6: this.encabezadosFast.matriculas_liquidadas,
            },
          ]

          this.datosTablaHeaders6 = [
            {
              columna1: 'Nvas. Liq. INBI',
              columna2: ` ${ this.encabezados.matriculas_liquidadasSemAnt} => ${ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.encabezados.matriculas_liquidadas_montoSemAnt ) }`,
              columna3: ` ${ this.encabezados.matriculas_liquidadas} => ${ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.encabezados.matriculas_liquidadas_monto ) }`,
              columna5: this.encabezados.matriculas_liquidadasSemAnt,
              columna6: this.encabezados.matriculas_liquidadas,
            },
          ]


          if (this.root) {
            this.root.dispose(); // ✅ Importante para evitar memory leaks
          }

          // this.grafica_data = this.encabezados.matriculas_liquidadasSemAnt > this.encabezados.matriculas_liquidadasSemAnt ? this.vendedorasActuales :  this.vendedorasActualesFAST
          // this.grafica_data = this.encabezados.matriculas_liquidadasSemAnt < this.encabezadosFast.matriculas_liquidadasSemAnt ? this.datosTablaHeaders6 :  this.datosTablaHeaders5

          // this.crearGrafica( )
          /*this.cargar = false*/
          this.getCiclo( )



        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { /*this.cargar = false*/ })
      },

      inicializarFastAnt () {

        return 
        this.cargar    = true
        var payload = { fechaini: this.fechaini, escuela: this.escuela }

        return this.$http.post('kpi.ventasmomento.anterior', payload ).then(response=>{


        	// caoichovnonvavvv
        	this.encabezadosAnt         = response.data.encabezadosAnt
        	//this.encabezados_ant        = response.data.encabezadosAnt
        	this.encabezadosFastAnt     = response.data.encabezadosFastAnt
        	//this.encabezados_antFast    = response.data.encabezadosFastAnt
          
          this.datosTablaHeaders5Ant = [
            {
              columna1: 'Nvas. Liq. FAST',
              columna2: ` ${ this.encabezadosFastAnt.matriculas_liquidadasSemAnt} => ${ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.encabezadosFastAnt.matriculas_liquidadas_montoSemAnt ) }`,
              columna3: ` ${ this.encabezadosFastAnt.matriculas_liquidadas} => ${ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.encabezadosFastAnt.matriculas_liquidadas_monto ) }`,
              columna5: this.encabezadosFastAnt.matriculas_liquidadasSemAnt,
              columna6: this.encabezadosFastAnt.matriculas_liquidadas,
            },
          ]

          this.datosTablaHeaders6Ant = [
            {
              columna1: 'Nvas. Liq. INBI',
              columna2: ` ${ this.encabezadosAnt.matriculas_liquidadasSemAnt} => ${ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.encabezadosAnt.matriculas_liquidadas_montoSemAnt ) }`,
              columna3: ` ${ this.encabezadosAnt.matriculas_liquidadas} => ${ new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( this.encabezadosAnt.matriculas_liquidadas_monto ) }`,
              columna5: this.encabezadosAnt.matriculas_liquidadasSemAnt,
              columna6: this.encabezadosAnt.matriculas_liquidadas,
            },
          ]

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { /*this.cargar = false*/ })
      },

      async getCiclosActivos( ){
        try {
          const response = await this.$http.get('kpi.ciclos.all')
          this.ciclos = response.data
          
          const positionCiclo = this.ciclos.findIndex(item => item.ciclo == this.ciclo)
          // Validar que sea uno valido
          if(positionCiclo == 0 ){
            return this.validarErrorDirecto('El ciclo anterior esta cerrado, favor de abrir el ciclo anterior')
          }

          this.cicloAct = this.ciclos[ positionCiclo ]

          // Guardar un ciclo después
          this.cicloSup = this.ciclos[ positionCiclo + 1 ]

          // Guardar un ciclo anteriro
          this.cicloInf = this.ciclos[ positionCiclo - 1 ]
        } catch (error) {
          this.validarError( error.response.data.message )
          console.error( error )
        } finally {
          this.cargar = false
        }
      },

      async datosDeRI() {
        const payload = {"cicloPre":{"id_ciclo":456,"ciclo":"CICLO 07_26","fecha_inicio_ciclo":"2026-07-13 00:00:00","fecha_fin_ciclo":"2026-08-16 00:00:00","comentarios":"","fecha_alta":"2026-04-15 14:10:00","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-08-22 13:10:14","ciclo_abierto_sn":1,"id_ciclo_relacionado":457,"activo_ventas":0,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":1.54,"semana2":15.6,"semana3":21.87,"semana4":33.3,"semana5":27.7,"semana6":null},"cicloAct":{"id_ciclo":461,"ciclo":"CICLO 08_26","fecha_inicio_ciclo":"2026-08-17 00:00:00","fecha_fin_ciclo":"2026-09-13 00:00:00","comentarios":"","fecha_alta":"2026-05-15 18:03:08","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-08-25 12:34:27","ciclo_abierto_sn":1,"id_ciclo_relacionado":462,"activo_ventas":0,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":1.54,"semana2":15.6,"semana3":21.87,"semana4":33.3,"semana5":27.7,"semana6":null},"cicloSig":{"id_ciclo":463,"ciclo":"CICLO 09_26","fecha_inicio_ciclo":"2026-09-14 00:00:00","fecha_fin_ciclo":"2026-10-11 00:00:00","comentarios":"","fecha_alta":"2026-05-15 18:06:02","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-05-29 12:34:38","ciclo_abierto_sn":1,"id_ciclo_relacionado":464,"activo_ventas":1,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":null,"semana2":null,"semana3":null,"semana4":null,"semana5":null,"semana6":null}}
        await this.$http.post('kpi.cantactual', payload ).then(response=>{
          this.resultadoRi = response.data
          this.resultadoRiFiltro = this.resultadoRi.riPlantelesInbi

          //console.log( response.data )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },


      async getSemanaCicloActualYProximo () {
        this.dialogCarga = true
        await this.$http.get('kpi.dias.restantes.para.inscribirse')
        .then(response=>{
          //console.log( 'get dias restantes' )
          //console.log( response.data )

          this.segundaSemanaCicloActual = response.data.inicio_ciclo_actual
          this.segundoDomingoCicloProximo =  response.data.inicio_ciclo_siguiente

            this.dialogCarga = false
        }).catch(error=>{console.log(error)})
      },

      async getIngresosRechazados () {
        //console.clear()
        //console.log( 'iniciando get ingresos rechazados' )
        this.dialogCarga = true
        await this.$http.post('kpi.ventasmomento.ingresos')
        .then(response=>{
          //console.log( 'get ingresos rechazados' )
          //console.log( response.data )

          this.ingresosRechazados = response.data.ingresos || []

          this.dialogCarga = false

        })
        .catch(error=>{console.log(error)})
      },

      sumarDias(fecha, dias) {
        const f = new Date(fecha);         // convertir a Date
        f.setDate(f.getDate() + dias);     // sumar los días
        return f;                          // devuelve un objeto Date
      },

      formatFecha(fecha) {
        if (!fecha) return '';

        const meses = [
          'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
          'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];

        const f = new Date(fecha);
        const dia = f.getDate().toString().padStart(2, '0');
        const mes = meses[f.getMonth()];

        return `${dia} de ${mes}`;
      },

      diasFaltantes(fechaObjetivo) {
        const hoy = new Date();
        const objetivo = new Date(fechaObjetivo);

        const diffMs = objetivo - hoy; // diferencia en milisegundos
        const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

        return dias;
      },

      getCiclo () {
        this.dialogCarga = true
        const reqFast = this.$http.get('kpi.inscripciones.total.fast/' + this.id_ciclo_relacionado)
        const reqInbi = this.$http.get('kpi.inscripciones.total.inbi/' + this.id_ciclo)
        reqFast.then(response=>{
          this.dataTablaFastUno = response.data

          console.log( 'tabla FAST Uno' )
          console.log( response.data )

          

          let metaTotal = 0
          let faltanTotal = 0
          let hayFast = 0
          let totalContactos = 0
          let total_completos = 0
          let total_incompletos = 0
          let total_merca = 0
          let total_sucursal = 0
          //let total_fuera_ciclo = 0

          for( const i in this.dataTablaFastUno ){

            const { id_plantel, total } = this.dataTablaFastUno[i]

            const existeMeta = this.metas.find( el => el.id_plantel == id_plantel )

            let meta = existeMeta ? existeMeta.meta : 0

            metaTotal += meta
            hayFast   += total

            let faltan = meta - total
            this.dataTablaFastUno[i]['faltan'] = faltan
            this.dataTablaFastUno[i]['meta'] = meta
            this.dataTablaFastUno[i]['porcentaje_cumplido'] = meta > 0 ? ((total / meta) * 100).toFixed(2) + '%' : '0.00%'

          }

          // Ordenar el arreglo por la propiedad 'total' de forma descendente (mayor a menor)
          this.dataTablaFastUno.sort((a, b) => b.total - a.total);

          // Asignar una posición ('rank') a cada plantel basada en su posición en el arreglo ordenado
          this.dataTablaFastUno.forEach((plantel, index) => {
            plantel.position = index + 1; // La posición comienza en 1
            totalContactos += plantel.totalContactos
            total_completos += plantel.total_completos
            total_incompletos += plantel.total_incompletos
            total_merca += plantel.total_merca
            total_sucursal += plantel.total_sucursal
          });


          var payload = {
            plantel: 'Total',
            total: 0,
            total_fuera_ciclo: 0,
            total_completos: 0,
            total_incompletos: 0,
            total_sucursal: 0,
            total_merca: 0,
            inscritos_dentro_periodo: 0,
            inscritos_fuera_periodo: 0,
            prospectos: [],
            vendedoras: [],
            completos: [],
            incompletos: [],
            merca: [],
            sucursal: [],
          }

          // console.clear()

          let vendedorasCompletas = []

          for(const i in this.dataTablaFastUno){

            const { vendedoras } = this.dataTablaFastUno[i]

            vendedorasCompletas = vendedorasCompletas.concat( vendedoras )

            let total_fuera_ciclo = 0
            if( this.dataTablaFastUno[i].quienVendio ){

              // Sumar total quien vendio
              this.dataTablaFastUno[i].quienVendio.map( q => {
                total_fuera_ciclo += +q.total_registros_diferente_ciclo
              })
              
              this.dataTablaFastUno[i].total_fuera_ciclo= total_fuera_ciclo

            }
            
            payload.total += this.dataTablaFastUno[i].total
            payload.total_fuera_ciclo += +total_fuera_ciclo
            payload.total_completos += this.dataTablaFastUno[i].total_completos
            payload.total_incompletos += this.dataTablaFastUno[i].total_incompletos
            payload.total_sucursal += this.dataTablaFastUno[i].total_sucursal
            payload.total_merca += this.dataTablaFastUno[i].total_merca
            payload.inscritos_dentro_periodo += this.dataTablaFastUno[i].inscritos_dentro_periodo || 0;
            payload.inscritos_fuera_periodo += this.dataTablaFastUno[i].inscritos_fuera_periodo || 0;
            payload.prospectos.push( ...this.dataTablaFastUno[i].prospectos )
            // payload.vendedoras.push( this.dataTablaFastUno[i].vendedoras )
            payload.completos.push( ...this.dataTablaFastUno[i].completos )
            payload.incompletos.push( ...this.dataTablaFastUno[i].incompletos )
            payload.merca.push( ...this.dataTablaFastUno[i].merca )
            payload.sucursal.push( ...this.dataTablaFastUno[i].sucursal )
          }

          // Sacar vendedoras unicas y retornar un arreglo de objetos con el nombre_completo y el total_contactos, y luegoooo el campo total_contactos, se debe ir sumando por vendedora
          const vendedorasUnicas = [...new Set(vendedorasCompletas.map(v => v.nombre_completo))]
          let vendedorasUnicasObjetos = []
          for( const i in vendedorasUnicas ){
            vendedorasUnicasObjetos.push({ 
              nombre_completo: vendedorasUnicas[i], 
              total_contactos: vendedorasCompletas.filter(v => v.nombre_completo == vendedorasUnicas[i]).reduce((prev, curr) => prev + curr.total_contactos, 0), 
              usuario_asignado: vendedorasCompletas.find(v => v.nombre_completo == vendedorasUnicas[i]).usuario_asignado
            })
          }

          this.totalFast =  payload.total
          this.dataTablaFastUno.push({...payload,
            totalContactos,
            total_completos,
            total_incompletos,
            total_merca,
            total_sucursal,
            faltan: metaTotal - hayFast,
            meta: metaTotal,
            porcentaje_cumplido: metaTotal > 0 ? ((hayFast / metaTotal) * 100).toFixed(2) + '%' : '0.00%',
            vendedoras: vendedorasUnicasObjetos
           })
          
            

          totalContactos = 0;
          total_completos=0
          total_incompletos=0
          total_merca=0
          total_sucursal=0

          reqInbi.then(response=>{

            this.dataTablaInbiUno = response.data

            console.log( 'tabla INBI Uno' )
            console.log( response.data )

            let metaTotalI = 0
            let faltanTotalI = 0
            let hayFastI = 0
            let vendedorasCompletasInbi = []


            for( const i in this.dataTablaInbiUno ){

              const { id_plantel, total } = this.dataTablaInbiUno[i]

              switch( id_plantel ){
                case 21: 
                  this.dataTablaInbiUno[i]['meta_money'] = '6050' 
                break;
                
                case 25: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3850' 
                break;
                
                case 1: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3930' 
                break;
                
                case 10015: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3820' 
                break;
                
                case 4: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3740' 
                break;
                
                case 24: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3530' 
                break;
                
                case 23: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3520' 
                break;
                
                case 32: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3430' 
                break;
                
                case 22: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3140' 
                break;
                
                case 3: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3190' 
                break;
                
                case 6: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3060' 
                break;
                
                case 31: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2980' 
                break;
                
                case 28: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2840' 
                break;
                
                case 10004: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2870' 
                break;
                
                case 29: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2640' 
                break;
                
                case 17: 
                  this.dataTablaInbiUno[i]['meta_money'] = '3660' 
                break;
                
                case 5: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2680' 
                break;
                
                case 27: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2600' 
                break;
                
                case 2: 
                  this.dataTablaInbiUno[i]['meta_money'] = '2330' 
                break;

              }


              const existeMeta = this.metas.find( el => el.id_plantel == id_plantel )

              let meta = existeMeta ? existeMeta.meta : 0

              metaTotalI += meta
              hayFastI   += total

              let faltan = meta - total
              this.dataTablaInbiUno[i]['faltan'] = faltan
              this.dataTablaInbiUno[i]['meta'] = meta
              this.dataTablaInbiUno[i]['porcentaje_cumplido'] = meta > 0 ? ((total / meta) * 100).toFixed(2) + '%' : '0.00%'
            }

            // Ordenar el arreglo por la propiedad 'total' de forma descendente (mayor a menor)
            this.dataTablaInbiUno.sort((a, b) => b.total - a.total);

            // Asignar una posición ('rank') a cada plantel basada en su posición en el arreglo ordenado
            this.dataTablaInbiUno.forEach((plantel, index) => {
              plantel.position = index + 1; // La posición comienza en 1
              totalContactos += plantel.totalContactos
              total_completos += plantel.total_completos
              total_incompletos += plantel.total_incompletos
              total_merca += plantel.total_merca
              total_sucursal += plantel.total_sucursal
            });


            var payload = {
              plantel: 'Total',
              total:0,
              total_fuera_ciclo: 0,
              total_completos:0,
              total_incompletos:0,
              total_sucursal: 0,
              total_merca: 0,
              inscritos_dentro_periodo: 0,
              inscritos_fuera_periodo: 0,
              prospectos: [],
              completos: [],
              incompletos: [],
              merca: [],
              sucursal: [],
            }
            for(const i in this.dataTablaInbiUno){

              const { vendedoras } = this.dataTablaInbiUno[i]

              vendedorasCompletasInbi = vendedorasCompletasInbi.concat( vendedoras )

              let total_fuera_ciclo = 0
              if( this.dataTablaInbiUno[i].quienVendio ){

                // Sumar total quien vendio
                this.dataTablaInbiUno[i].quienVendio.map( q => {
                  total_fuera_ciclo += +q.total_registros_diferente_ciclo
                })
                
                this.dataTablaInbiUno[i].total_fuera_ciclo= total_fuera_ciclo

              }

              // console.log( 'TOTALINBI' )
              // console.log( total_fuera_ciclo )

              payload.total += this.dataTablaInbiUno[i].total
              payload.total_fuera_ciclo += +total_fuera_ciclo
              payload.total_completos += this.dataTablaInbiUno[i].total_completos
              payload.total_incompletos += this.dataTablaInbiUno[i].total_incompletos
              payload.total_sucursal += this.dataTablaInbiUno[i].total_sucursal
              payload.total_merca += this.dataTablaInbiUno[i].total_merca
              payload.inscritos_dentro_periodo += this.dataTablaInbiUno[i].inscritos_dentro_periodo || 0;
              payload.inscritos_fuera_periodo += this.dataTablaInbiUno[i].inscritos_fuera_periodo || 0;
              payload.prospectos.push( ...this.dataTablaInbiUno[i].prospectos )
              payload.completos.push( ...this.dataTablaInbiUno[i].completos )
              payload.incompletos.push( ...this.dataTablaInbiUno[i].incompletos )
              payload.merca.push( ...this.dataTablaInbiUno[i].merca )
              payload.sucursal.push( ...this.dataTablaInbiUno[i].sucursal )
            }

            // Sacar vendedoras unicas y retornar un arreglo de objetos con el nombre_completo y el total_contactos, y luegoooo el campo total_contactos, se debe ir sumando por vendedora
            const vendedorasUnicasInbi = [...new Set(vendedorasCompletasInbi.map(v => v.nombre_completo))]
            let vendedorasUnicasObjetosInbi = []
            for( const i in vendedorasUnicasInbi ){
              vendedorasUnicasObjetosInbi.push({ 
                nombre_completo: vendedorasUnicasInbi[i], 
                total_contactos: vendedorasCompletasInbi.filter(v => v.nombre_completo == vendedorasUnicasInbi[i]).reduce((prev, curr) => prev + curr.total_contactos, 0), 
                usuario_asignado: vendedorasCompletasInbi.find(v => v.nombre_completo == vendedorasUnicasInbi[i]).usuario_asignado
              })
            }
            this.totalInbi =  payload.total
            this.dataTablaInbiUno.push({...payload,
              totalContactos,
              total_completos,
              total_incompletos,
              total_merca,
              total_sucursal,
              faltan: metaTotalI - hayFastI, 
              meta: metaTotalI,
              porcentaje_cumplido: metaTotalI > 0 ? ((hayFastI / metaTotalI) * 100).toFixed(2) + '%' : '0.00%',
              vendedoras: vendedorasUnicasObjetosInbi
            })
            this.dialogCarga = false
          }).catch(error=>{console.log(error)})
        }).catch(error=>{console.log(error)})
      },

      verDetalle(prospectos, vendedoras, item){
        console.log( "ITEM", item)
        this.prospectosInscritos = []
        this.prospectosInscritosSucursal = []
        this.vendedoras = []
        // console.log( prospectos )
        this.prospectosInscritos = prospectos
        if( item && item.id_plantel ){
          this.prospectosInscritosSucursal = [item]
        }
        this.vendedoras = vendedoras && vendedoras.length ? vendedoras : []
        this.dialogInscritosProspectos = true
      },

      verQuienVendio(alumnos, item ) {
        this.quienVendio       = []
        
        if (alumnos && alumnos.length) {
          this.quienVendio = alumnos.map(a => {
            let tiempo = 'N/A';
            if (a.fecha_creacion && a.fecha_finalizo) {
              const f1 = new Date(a.fecha_creacion);
              const f2 = new Date(a.fecha_finalizo);
              const diffTime = Math.abs(f2 - f1);
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
              tiempo = diffDays + (diffDays === 1 ? ' día' : ' días');
            }
            return {
              ...a,
              tiempo_transcurrido: tiempo
            }
          });
        }

        this.itemSucursal      = item
        this.dialogQuienVendio = true
      },

      initialize2() {
        // Abrimos modal de carga
        this.cargar = true
        // Limpiamos los prospectos
        this.prospectos  = []

        return this.$http.get('prospectos.vendedora/' + 2 + '/' + this.getdatosUsuarioERPERP.iderp).then((response) => {
          // Filtramos los que necesitamos, depende si es vendedora o administrador
          this.prospectos = response.data.respuesta

          // Prospectos que se encuentran el inducción o tienen tarea programada que no es para hoy
          this.prospectosAgendadaInduccion  = response.data.prospectosConSeguimiento.concat( response.data.prospectosAgendadaInduccion )

          // Prospectos sin seguimiento hoy y sin tareas programadas
          this.prospectosSeguimiento        = response.data.prospectosSeguimiento

          /*this.cargar = false*/
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { /*this.cargar = false*/ })
      },

      initialize3() {
        const payload = {
        	fecha_inicio: this.fecha_inicio,
        	fecha_final:  this.fecha_final
        }

        // Mandamos a llamar a la api
        this.$http.post('marketing.contactos',payload).then(response=>{

					for( const i in this.vendedorasActuales ){

						const { nombre_completo, id_usuario } = this.vendedorasActuales[i]

						this.vendedorasActuales[i]['atrasados']   = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa == 1 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActuales[i]['nuevos']      = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa == 2 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActuales[i]['seguimiento'] = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length + this.prospectosAgendadaInduccion.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActuales[i]['total'] = this.prospectosSeguimiento.filter((el)=>{ return el.usuario_asignado == id_usuario }).length + this.prospectosAgendadaInduccion.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length

						const existe = response.data.dataTabla.find( el => el.usuario_asignado == id_usuario )
						this.vendedorasActuales[i]['contactos'] = existe ? existe[`${this.fecha_inicio}`] : 0

					}

					for( const i in this.vendedorasActualesFAST ){

						const { nombre_completo, id_usuario } = this.vendedorasActualesFAST[i]

						this.vendedorasActualesFAST[i]['atrasados']   = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa == 1 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActualesFAST[i]['nuevos']      = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa == 2 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActualesFAST[i]['seguimiento'] = this.prospectosSeguimiento.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length + this.prospectosAgendadaInduccion.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length
						this.vendedorasActualesFAST[i]['total'] = this.prospectosSeguimiento.filter((el)=>{ return el.usuario_asignado == id_usuario }).length + this.prospectosAgendadaInduccion.filter((el)=>{ return el.idetapa > 2 && el.usuario_asignado == id_usuario }).length

						const existe = response.data.dataTabla.find( el => el.usuario_asignado == id_usuario )
						this.vendedorasActualesFAST[i]['contactos'] = existe ? existe[`${this.fecha_inicio}`] : 0

					}

					this.vendedorasActuales     = [...this.vendedorasActuales].sort((a, b) => b.contactos - a.contactos);
					this.vendedorasActualesFAST = [...this.vendedorasActualesFAST].sort((a, b) => b.contactos - a.contactos);

					this.vendedorasActuales.push({
		        nombre_completo: 'TOTAL',
		        atrasados      : this.vendedorasActuales.map(item => item.atrasados).reduce((prev, curr) => prev + curr, 0),
		        nuevos         : this.vendedorasActuales.map(item => item.nuevos).reduce((prev, curr) => prev + curr, 0),
		        seguimiento    : this.vendedorasActuales.map(item => item.seguimiento).reduce((prev, curr) => prev + curr, 0),
		        total          : this.vendedorasActuales.map(item => item.total).reduce((prev, curr) => prev + curr, 0),
		        contactos      : this.vendedorasActuales.map(item => item.contactos).reduce((prev, curr) => prev + curr, 0),
		        escuela        : 1,
		        matriculas_liquidadas: this.vendedorasActuales.map(item => item.matriculas_liquidadas).reduce((prev, curr) => prev + curr, 0),
		      })

		      this.vendedorasActualesFAST.push({
		        nombre_completo: 'TOTAL',
		        atrasados      : this.vendedorasActualesFAST.map(item => item.atrasados).reduce((prev, curr) => prev + curr, 0),
		        nuevos         : this.vendedorasActualesFAST.map(item => item.nuevos).reduce((prev, curr) => prev + curr, 0),
		        seguimiento    : this.vendedorasActualesFAST.map(item => item.seguimiento).reduce((prev, curr) => prev + curr, 0),
		        total          : this.vendedorasActualesFAST.map(item => item.total).reduce((prev, curr) => prev + curr, 0),
		        contactos      : this.vendedorasActualesFAST.map(item => item.contactos).reduce((prev, curr) => prev + curr, 0),
		        escuela        : 2,
		        matriculas_liquidadas: this.vendedorasActualesFAST.map(item => item.matriculas_liquidadas).reduce((prev, curr) => prev + curr, 0),
		      })

          // Ventas semana
					this.reporteFast = this.vendedorasActualesFAST.filter( el => el.escuela == 2 )
          console.log( 'reporte fast' )
          console.log( this.reporteFast )
					this.reporteInbi = this.vendedorasActuales.filter( el => el.escuela == 1 )

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { /*this.cargar = false*/ })
      },

      riSucursales () {

        this.miniReporte = []

        this.cargar = true
        const payload = {"cicloPre":{"id_ciclo":456,"ciclo":"CICLO 07_26","fecha_inicio_ciclo":"2026-07-13 00:00:00","fecha_fin_ciclo":"2026-08-16 00:00:00","comentarios":"","fecha_alta":"2026-04-15 14:10:00","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-08-22 13:10:14","ciclo_abierto_sn":1,"id_ciclo_relacionado":457,"activo_ventas":0,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":1.54,"semana2":15.6,"semana3":21.87,"semana4":33.3,"semana5":27.7,"semana6":null},"cicloAct":{"id_ciclo":461,"ciclo":"CICLO 08_26","fecha_inicio_ciclo":"2026-08-17 00:00:00","fecha_fin_ciclo":"2026-09-13 00:00:00","comentarios":"","fecha_alta":"2026-05-15 18:03:08","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-08-25 12:34:27","ciclo_abierto_sn":1,"id_ciclo_relacionado":462,"activo_ventas":0,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":1.54,"semana2":15.6,"semana3":21.87,"semana4":33.3,"semana5":27.7,"semana6":null},"cicloSig":{"id_ciclo":463,"ciclo":"CICLO 09_26","fecha_inicio_ciclo":"2026-09-14 00:00:00","fecha_fin_ciclo":"2026-10-11 00:00:00","comentarios":"","fecha_alta":"2026-05-15 18:06:02","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-05-29 12:34:38","ciclo_abierto_sn":1,"id_ciclo_relacionado":464,"activo_ventas":1,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":null,"semana2":null,"semana3":null,"semana4":null,"semana5":null,"semana6":null}}
        return this.$http.post('kpi.cantactual', payload ).then(response=>{

          let fastRI = response.data.riPlantelesFast.find( el => el.plantel == 'TOTAL')
          let inbiRI = response.data.riPlantelesInbi.find( el => el.plantel == 'TOTAL')

          let fastMenor = response.data.riPlantelesFast.filter( el => el.reinscribibles > 0 ).sort((a, b) => a.porcentajeAvance - b.porcentajeAvance)

          let inbiMenor = response.data.riPlantelesInbi.filter( el => el.reinscribibles > 0 ).sort((a, b) => a.porcentajeAvance - b.porcentajeAvance)

          this.miniReporte.push({
            escuela: 'FAST',
            ritotal: '%' + fastRI.porcentajeAvance,
            risucursal: fastMenor[0].plantel + ' ( %' + fastMenor[0].porcentajeAvance + ')',
            dif: 0,
            sucursalni:'',
            monto1: this.totalFast + ' de ' + 145
          })

          this.miniReporte.push({
            escuela: 'INBI',
            ritotal: '%' + inbiRI.porcentajeAvance,
            risucursal: inbiMenor[0].plantel + ' ( %' + inbiMenor[0].porcentajeAvance + ')',
            dif: 0,
            sucursalni:'',
            monto1: this.totalInbi + ' de ' + 401
          })

          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      riSucursalesMonto () {
        this.cargar = true
        const payload = {"cicloPre":{"id_ciclo":456,"ciclo":"CICLO 07_26","fecha_inicio_ciclo":"2026-07-13 00:00:00","fecha_fin_ciclo":"2026-08-16 00:00:00","comentarios":"","fecha_alta":"2026-04-15 14:10:00","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-08-22 13:10:14","ciclo_abierto_sn":1,"id_ciclo_relacionado":457,"activo_ventas":0,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":1.54,"semana2":15.6,"semana3":21.87,"semana4":33.3,"semana5":27.7,"semana6":null},"cicloAct":{"id_ciclo":461,"ciclo":"CICLO 08_26","fecha_inicio_ciclo":"2026-08-17 00:00:00","fecha_fin_ciclo":"2026-09-13 00:00:00","comentarios":"","fecha_alta":"2026-05-15 18:03:08","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-08-25 12:34:27","ciclo_abierto_sn":1,"id_ciclo_relacionado":462,"activo_ventas":0,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":1.54,"semana2":15.6,"semana3":21.87,"semana4":33.3,"semana5":27.7,"semana6":null},"cicloSig":{"id_ciclo":463,"ciclo":"CICLO 09_26","fecha_inicio_ciclo":"2026-09-14 00:00:00","fecha_fin_ciclo":"2026-10-11 00:00:00","comentarios":"","fecha_alta":"2026-05-15 18:06:02","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-05-29 12:34:38","ciclo_abierto_sn":1,"id_ciclo_relacionado":464,"activo_ventas":1,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":null,"semana2":null,"semana3":null,"semana4":null,"semana5":null,"semana6":null}}
        this.cargar = false
        return this.$http.post('kpi.cantactual.montos', payload ).then(response=>{

          let fastMenor = response.data.riPlantelesFast.filter( el => el.plantel != 'TOTAL' ).sort((a, b) => a.diferencia - b.diferencia)

          let inbiMenor = response.data.riPlantelesInbi.filter( el => el.plantel != 'TOTAL' ).sort((a, b) => a.diferencia - b.diferencia)

          this.miniReporte[0].dif = fastMenor[0].plantel
          this.miniReporte[1].dif = inbiMenor[0].plantel


          let fastMenor2 = response.data.riPlantelesFast.filter( el => el.plantel != 'TOTAL' ).sort((a, b) => a.niActual - b.niActual)

          let inbiMenor2 = response.data.riPlantelesInbi.filter( el => el.plantel != 'TOTAL' ).sort((a, b) => a.niActual - b.niActual)
          this.miniReporte[0].sucursalni = fastMenor2[0].plantel + ' ( ' + new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( fastMenor2[0].niActual ) + ' ) '
          this.miniReporte[1].sucursalni = inbiMenor2[0].plantel + ' ( ' + new Intl.NumberFormat("en-US",{style: "currency", currency: "USD"}).format( inbiMenor2[0].niActual ) + ' ) '


        }).catch( error =>{
          console.log( error )
          this.validarError( error.response )
        }).finally( () => { this.cargar = false })
      },

      abrirDialog( value ){
        this.alumnos = value
        this.dialogAlumnos = true
      },

      exportar(){
        this.exportarData()
      },

      s2ab2(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },

      format( valor ){
        return valor.toLocaleString('es-MX', {
          style: 'currency',
          currency: 'MXN'
        });
      },

      calcularConvencimiento(inscritos, totalContactos) {
        if (!totalContactos || totalContactos === 0) return 0;
        const porcentaje = (inscritos / totalContactos) * 100;
        return porcentaje.toFixed(2); // dos decimales
      },

      traducirEstado(valor) {
        const estados = {
          0: 'Sin plantel',
          1: 'Monterrey',
          2: 'CDMX',
          3: 'GDL',
          4: 'FAST'
        };
        return estados[valor] || '';
      },

      calcularTotal(data) {
        const total = {
          id_usuario: 'Total',  // O un valor fijo como "Total"
          nombre_completo: 'Total',  // Nombre o campo estático para el total
          escuela: '',
          estado: '',
          matriculas_liquidadas: 0,  // Solo calcularemos la suma de este campo
        };

        // Sumar los valores de "matriculas_liquidadas"
        data.forEach(item => {
          total.matriculas_liquidadas += item.matriculas_liquidadas;
        });

        return total;  // Regresa el objeto "Total"
      },

      construirTablaVentasCiclo(esInbi, estadoFiltro) {
        let base = (esInbi ? this.tablaInbi : this.tablaFast)
          .filter(el => ![87].includes(Number(el.id_usuario_ultimo_cambio || el.id_usuario)));
        let fuente = esInbi ? this.vendedorasActuales : this.vendedorasActualesFAST;
        const dataTabla = esInbi ? this.dataTablaInbiUno : this.dataTablaFastUno;
        const totalesRow = dataTabla ? dataTabla.find(row => row.plantel === 'Total') : null;
        const vendedorasTotales = totalesRow && totalesRow.vendedoras ? totalesRow.vendedoras : [];

        base = base.map(el => {
          if(el.totalA && el.totalA.length > 0){
            const mapTotalA = new Map(el.totalA.map(el => [el.id_prospecto, el]));
            el.contactos_twilio_lista = el.contactos_twilio_lista.map(i => {
              i.inscrito = mapTotalA.has(i.idprospectos) ? 'SI' : 'NO';
              return i;
            });
          }
          return el;
        });

        fuente = fuente.map(el => {
          if(el.nuevasMatriculas && el.nuevasMatriculas.length > 0){
            const mapTotalA = new Map(el.nuevasMatriculas.map(el => [el.id_prospecto, el]));
            if(el.contactos_twilio_lista && el.contactos_twilio_lista.length){
              el.contactos_twilio_lista = el.contactos_twilio_lista.map(i => {
                i.inscrito = mapTotalA.has(i.idprospectos) ? 'SI' : 'NO';
                return i;
              });
            }
          }
          return el;
        });

        
        let resultado = base.map(item => {
          const inscritosDentroPeriodoContactos =  item.contactos_twilio_lista.filter(i => i.inscrito === 'SI')

          
          const idsProspectos = inscritosDentroPeriodoContactos.map(i => i.idprospectos)

          if (item.totalA && item.totalA.length > 0) {
            item.inscritosDentroPeriodo = item.totalA.filter(i => idsProspectos.includes(i.id_prospecto))
            item.inscritosDentroPeriodoCount = item.inscritosDentroPeriodo.length
            item.inscritosFueraPeriodo =  item.totalA.filter(i => !idsProspectos.includes(i.id_prospecto))
            item.inscritosFueraPeriodoCount = item.inscritosFueraPeriodo.length
            item.inscritosTotales = [...item.inscritosDentroPeriodo, ...item.inscritosFueraPeriodo]
            item.inscritosTotalesCount = item.inscritosTotales.length
          } else {
            item.inscritosDentroPeriodo = []
            item.inscritosDentroPeriodoCount = 0
            item.inscritosFueraPeriodo = []
            item.inscritosFueraPeriodoCount = 0
            item.inscritosTotales = []
            item.inscritosTotalesCount = 0
          }


          const match = fuente.find(v => v.nombre_completo === item.vendedora);
          

          let pct = item.total_contactos > 0 ? ((item.inscritosDentroPeriodoCount / item.total_contactos) * 100).toFixed(2) : '0.00';

          return {
            ...item,
            total_contactos: item.contactos_twilio_lista.length,
            porcentaje_conversion_periodo: pct,
            contactos_twilio: match && match.contactos_twilio ? match.contactos_twilio : [],
          };
        });

        if (estadoFiltro) {
          resultado = resultado.filter(t => t.estado === estadoFiltro);
        }

        if (resultado.length > 0) {
          const total_contactos = resultado.reduce((acc, curr) => acc + (curr.total_contactos || 0), 0);
          const inscritosTotalesCount = resultado.reduce((acc, curr) => acc + (curr.inscritosTotalesCount || 0), 0);
          const inscritosDentroPeriodoCount = resultado.reduce((acc, curr) => acc + (curr.inscritosDentroPeriodoCount || 0), 0);
          const inscritosFueraPeriodoCount = resultado.reduce((acc, curr) => acc + (curr.inscritosFueraPeriodoCount || 0), 0);
          const porcentaje_conversion_periodo = total_contactos > 0 ? ((inscritosDentroPeriodoCount / total_contactos) * 100).toFixed(2) : '0.00';

          const sumContactosVendedoras = total_contactos;
          this.contactosInvisibles = totalesRow ? (totalesRow.totalContactos - sumContactosVendedoras) : 0;
          this.inscritosInvisibles = totalesRow ? (totalesRow.total - inscritosTotalesCount) : 0;

          let contactos_twilio_lista = [];
          let inscritosDentroPeriodo = [];
          let inscritosFueraPeriodo = [];
          let inscritosTotales = [];
          let inscritos_dentro_list = [];
          let inscritos_fuera_list = [];

          resultado.forEach(curr => {
            if (curr.contactos_twilio_lista) contactos_twilio_lista.push(...curr.contactos_twilio_lista);
            if (curr.inscritosDentroPeriodo) inscritosDentroPeriodo.push(...curr.inscritosDentroPeriodo);
            if (curr.inscritosFueraPeriodo) inscritosFueraPeriodo.push(...curr.inscritosFueraPeriodo);
            if (curr.inscritosTotales) inscritosTotales.push(...curr.inscritosTotales);
            if (curr.inscritos_dentro_list) inscritos_dentro_list.push(...curr.inscritos_dentro_list);
            if (curr.inscritos_fuera_list) inscritos_fuera_list.push(...curr.inscritos_fuera_list);
          });

          resultado.push({
            vendedora: 'TOTAL',
            puesto: '',
            plantel: '',
            estado: '',
            total_contactos,
            inscritos_periodo: inscritosTotalesCount,
            inscritosTotalesCount,
            inscritos_dentro_periodo: inscritosDentroPeriodoCount,
            inscritosDentroPeriodoCount,
            inscritos_fuera_periodo: inscritosFueraPeriodoCount,
            inscritosFueraPeriodoCount,
            porcentaje_conversion_periodo,
            completosA: [],
            contactos_twilio_lista,
            inscritosDentroPeriodo,
            inscritosFueraPeriodo,
            inscritosTotales,
            inscritos_dentro_list,
            inscritos_fuera_list,
            isTotal: true
          });
        }

        this.tablaVentasCiclo = resultado;
      },

      onCiudadChangeVentasCicloVendedora(){
        const r = this.traducirEstado( this.inbiFilter )
        this.construirTablaVentasCiclo(this.tablaVentaCicloInbi, r)
      },

      onCiudadChangeRI(){

        this.resultadoRiFiltro = this.resultadoRi.riPlantelesInbi

        if( this.inbiFilter )
        this.resultadoRiFiltro =
        this.resultadoRiFiltro.filter( t => +t.estado === this.inbiFilter)

      },

      

      abrirModalPagosRechazados(tipo) {
        console.log( 'abriendo modal de pagos rechazados' )
        this.tipoPagosRechazados = tipo;
        this.dialogPagosRechazados = true;
      },

      abrirDialogoTwilioInscritos(lista, titulo) {
        this.listaTwilioDetalle = lista || [];
        this.tituloTwilioDetalle = titulo || 'Detalle de Contactos';
        this.dialogTwilioDetalle = true;
      },

      exportarVentasCiclo() {
        const dataExport = this.tablaVentasCiclo.map(item => {
          return {
            'Vendedora': item.vendedora,
            'Puesto': item.puesto,
            'Plantel': item.plantel,
            'Ciudad': item.estado,
            'Contactos asignados': item.total_contactos,
            'Inscritos Totales': item.inscritosTotalesCount,
            'Insc. Dentro del periodo': item.inscritosDentroPeriodoCount,
            'Insc. Fuera del periodo': item.inscritosFueraPeriodoCount,
            '% Conversión Semanal': item.porcentaje_conversion_periodo + '%'
          }
        });
        this.exportarExcelDirecto(dataExport, 'Ventas_por_ciclo_por_vendedora');
      },

      telefonoContactoExport(item) {
        if (!item) return '';
        const raw = item.twilio || item.telefono || '';
        if (!raw) return '';
        return String(raw).replace(/\D/g, '').slice(-10);
      },

      exportarContactosTwilio() {
        const items = this.filterTablaContactos || [];
        if (!items.length) {
          this.validarError('No hay contactos para exportar');
          return;
        }

        const dataExport = items.map(item => {
          const telefono = this.telefonoContactoExport(item);
          const telefonoRaw = item.twilio || item.telefono || '';
          return {
            'Inscrito': item.inscrito || (item.esta_inscrito ? 'SI' : 'NO'),
            'Folio': item.folio || '',
            'Nombre': item.nombre_completo || '',
            'Creó': item.nombre_creo || '',
            'Vendedora': item.nombre_vendedora || '',
            'Sucursal interés': (item.nombre_plantel && item.nombre_plantel !== 'SIN PLANTEL') ? item.nombre_plantel : 'SIN DATO',
            'Fecha': item.fecha_alta_prospecto_sistema || item.fecha_creacion || '',
            'Clasificación': item.clasificacion || '',
            'Total de mensajes': item.total_mensajes || 0,
            'Mis Mensajes': item.mensajes_sistema || 0,
            'Mensajes Usuario': item.mensajes_usuario || 0,
            'Teléfono': telefono,
            'Teléfono WhatsApp': telefonoRaw ? this.$options.filters.formatTelefono(telefonoRaw) : '',
            'Etiqueta': this.getNombreEtiqueta(item),
            'Correo': item.correo || '',
            'Sistema': item.sistema || '',
            'ID Prospecto': item.idprospectos || item.id_prospecto || '',
          };
        });

        let nombreArchivo = (this.tituloTwilio || 'Datos_de_los_contactos')
          .replace(/[^\w\s-áéíóúñÁÉÍÓÚÑ]/g, '')
          .trim()
          .replace(/\s+/g, '_');

        if (this.filtroEtiquetaSelected) {
          const etiqueta = (this.etiquetas || []).find(e => e.idetiquetas === Number(this.filtroEtiquetaSelected));
          if (etiqueta && etiqueta.text) {
            nombreArchivo += '_' + etiqueta.text.replace(/\s+/g, '_');
          }
        }

        this.exportarExcelDirecto(dataExport, nombreArchivo);
      },

      exportarVentasSemana() {
        // Obtenemos los datos filtrados
        const items = this.dataTablaSemanaFiltered || [];
        
        // Mapeamos los datos
        let dataExport = items.map(item => {
          return {
            'Vendedora': item.nombre_completo,
            'Contactos asignados': item.total_contactos,
            'Inscritos del Periodo': item.matriculas_liquidadas,
            'Inscritos dentro del periodo': item.inscritos_dentro_periodo,
            'Inscritos fuera del periodo': item.inscritos_fuera_periodo,
            '% Conversión Semanal': item.porcentaje_conversion_periodo + '%'
          }
        });

        // Agregamos la fila de TOTALES si hay datos
        if (items.length > 0) {
          const total_contactos = items.reduce((s, i) => s + (i.total_contactos || 0), 0);
          const matriculas_liquidadas = items.reduce((s, i) => s + (i.matriculas_liquidadas || 0), 0);
          const inscritos_dentro_periodo = items.reduce((s, i) => s + (i.inscritos_dentro_periodo || 0), 0);
          const inscritos_fuera_periodo = items.reduce((s, i) => s + (i.inscritos_fuera_periodo || 0), 0);
          const porcentaje = total_contactos > 0 ? (((inscritos_dentro_periodo + inscritos_fuera_periodo) / total_contactos) * 100).toFixed(2) : '0.00';

          dataExport.push({
            'Vendedora': 'TOTAL',
            'Contactos asignados': total_contactos,
            'Inscritos del Periodo': matriculas_liquidadas,
            'Inscritos dentro del periodo': inscritos_dentro_periodo,
            'Inscritos fuera del periodo': inscritos_fuera_periodo,
            '% Conversión Semanal': porcentaje + '%'
          });
        }

        this.exportarExcelDirecto(dataExport, this.tituloSemana.replace(/\s+/g, '_'));
      },

    },
  }
</script>

<style scoped>
.hello {
  width: 100%;
  height: 500px;
}

.whatsapp-container {
  overflow: hidden;
  border-radius: 8px !important;
}

.whatsapp-header {
  background-color: #1565C0 !important;
  color: white !important;
}

.whatsapp-bg {
  background-color: #f0f2f5;
  scrollbar-width: thin;
  scrollbar-color: #bab3ae transparent;
}

.whatsapp-bg::-webkit-scrollbar {
  width: 6px;
}

.whatsapp-bg::-webkit-scrollbar-thumb {
  background-color: #bab3ae;
  border-radius: 10px;
}

.bubble {
  position: relative;
  max-width: 85%;
  border-radius: 8px;
  font-size: 0.85rem;
  line-height: 1.4;
  box-shadow: 0 1px 0.5px rgba(0,0,0,0.13) !important;
}

.incoming {
  background-color: #ffffff;
  border-top-left-radius: 0;
}

.outgoing {
  background-color: #E3F2FD;
  border-top-right-radius: 0;
}

.bubble-text {
  word-wrap: break-word;
  white-space: pre-wrap;
}

.bubble-time {
  font-size: 0.65rem !important;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 2px;
}

.chat-day-separator-wrap {
  display: flex;
  justify-content: center;
  margin: 10px 0 6px;
}

.chat-day-pill {
  background: rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.55);
  font-size: 0.7rem;
  padding: 5px 14px;
  border-radius: 8px;
  font-weight: 500;
  max-width: 95%;
  text-align: center;
  line-height: 1.25;
}

.hide-scrollbar {
  overflow: hidden !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none !important;
}
</style>

<style>
/* Diálogo anidado: por encima del overlay de «Ventas por ciclo por vendedora» */
.dialog-alumnos-ventas-ciclo {
  z-index: 2500 !important;
}
</style>
